import React from "react";
import { Col, Container, Nav, Row } from "react-bootstrap";
import Footer from "../../layouts/Footer";
import HeaderMobile from "../../layouts/HeaderMobile";

export default function IconRemix() {
  return (
    <React.Fragment>
      <HeaderMobile />
      <div className="main main-docs">
        <Container>
          <label className="main-title-label">Maps and Icons</label>
          <h2 className="main-title">Remixicon</h2>
          <p className="main-title-text">Remix Icon is a set of open-source neutral-style system symbols elaborately crafted for designers and developers.</p>

          <hr className="main-separator" />

          <h5 id="section1" className="main-subtitle">Buildings</h5>

          <div className="icon-group">
            <Row className="gx-1 gy-2">
              <Col><i className="ri-home-line"></i></Col>
              <Col><i className="ri-home-2-line"></i></Col>
              <Col><i className="ri-home-3-line"></i></Col>
              <Col><i className="ri-home-4-line"></i></Col>
              <Col><i className="ri-home-5-line"></i></Col>
              <Col><i className="ri-home-6-line"></i></Col>
              <Col><i className="ri-home-7-line"></i></Col>
              <Col><i className="ri-home-8-line"></i></Col>
              <Col><i className="ri-home-gear-line"></i></Col>
              <Col><i className="ri-home-wifi-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-home-fill"></i></Col>
              <Col><i className="ri-home-2-fill"></i></Col>
              <Col><i className="ri-home-3-fill"></i></Col>
              <Col><i className="ri-home-4-fill"></i></Col>
              <Col><i className="ri-home-5-fill"></i></Col>
              <Col><i className="ri-home-6-fill"></i></Col>
              <Col><i className="ri-home-7-fill"></i></Col>
              <Col><i className="ri-home-8-fill"></i></Col>
              <Col><i className="ri-home-gear-fill"></i></Col>
              <Col><i className="ri-home-wifi-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-home-smile-line"></i></Col>
              <Col><i className="ri-home-smile-2-line"></i></Col>
              <Col><i className="ri-home-heart-line"></i></Col>
              <Col><i className="ri-building-line"></i></Col>
              <Col><i className="ri-building-2-line"></i></Col>
              <Col><i className="ri-building-3-line"></i></Col>
              <Col><i className="ri-building-4-line"></i></Col>
              <Col><i className="ri-hotel-line"></i></Col>
              <Col><i className="ri-community-line"></i></Col>
              <Col><i className="ri-government-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-home-smile-fill"></i></Col>
              <Col><i className="ri-home-smile-2-fill"></i></Col>
              <Col><i className="ri-home-heart-fill"></i></Col>
              <Col><i className="ri-building-fill"></i></Col>
              <Col><i className="ri-building-2-fill"></i></Col>
              <Col><i className="ri-building-3-fill"></i></Col>
              <Col><i className="ri-building-4-fill"></i></Col>
              <Col><i className="ri-hotel-fill"></i></Col>
              <Col><i className="ri-community-fill"></i></Col>
              <Col><i className="ri-government-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-bank-line"></i></Col>
              <Col><i className="ri-store-line"></i></Col>
              <Col><i className="ri-store-2-line"></i></Col>
              <Col><i className="ri-store-3-line"></i></Col>
              <Col><i className="ri-hospital-line"></i></Col>
              <Col><i className="ri-ancient-gate-line"></i></Col>
              <Col><i className="ri-ancient-pavilion-line"></i></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <div className="w-100"></div>
              <Col><i className="ri-bank-fill"></i></Col>
              <Col><i className="ri-store-fill"></i></Col>
              <Col><i className="ri-store-2-fill"></i></Col>
              <Col><i className="ri-store-3-fill"></i></Col>
              <Col><i className="ri-hospital-fill"></i></Col>
              <Col><i className="ri-ancient-gate-fill"></i></Col>
              <Col><i className="ri-ancient-pavilion-fill"></i></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
            </Row>
          </div>

          <br /><br /><br />

          <h5 id="section2" className="main-subtitle">Business</h5>

          <div className="icon-group">
            <Row className="gx-1 gy-2">
              <Col><i className="ri-mail-line"></i></Col>
              <Col><i className="ri-mail-open-line"></i></Col>
              <Col><i className="ri-mail-send-line"></i></Col>
              <Col><i className="ri-mail-unread-line"></i></Col>
              <Col><i className="ri-mail-add-line"></i></Col>
              <Col><i className="ri-mail-check-line"></i></Col>
              <Col><i className="ri-mail-close-line"></i></Col>
              <Col><i className="ri-mail-download-line"></i></Col>
              <Col><i className="ri-mail-forbid-line"></i></Col>
              <Col><i className="ri-mail-lock-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-mail-fill"></i></Col>
              <Col><i className="ri-mail-open-fill"></i></Col>
              <Col><i className="ri-mail-send-fill"></i></Col>
              <Col><i className="ri-mail-unread-fill"></i></Col>
              <Col><i className="ri-mail-add-fill"></i></Col>
              <Col><i className="ri-mail-check-fill"></i></Col>
              <Col><i className="ri-mail-close-fill"></i></Col>
              <Col><i className="ri-mail-download-fill"></i></Col>
              <Col><i className="ri-mail-forbid-fill"></i></Col>
              <Col><i className="ri-mail-lock-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-mail-settings-line"></i></Col>
              <Col><i className="ri-mail-star-line"></i></Col>
              <Col><i className="ri-mail-volume-line"></i></Col>
              <Col><i className="ri-inbox-line"></i></Col>
              <Col><i className="ri-inbox-archive-line"></i></Col>
              <Col><i className="ri-inbox-unarchive-line"></i></Col>
              <Col><i className="ri-cloud-line"></i></Col>
              <Col><i className="ri-cloud-off-line"></i></Col>
              <Col><i className="ri-attachment-line"></i></Col>
              <Col><i className="ri-profile-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-mail-settings-fill"></i></Col>
              <Col><i className="ri-mail-star-fill"></i></Col>
              <Col><i className="ri-mail-volume-fill"></i></Col>
              <Col><i className="ri-inbox-fill"></i></Col>
              <Col><i className="ri-inbox-archive-fill"></i></Col>
              <Col><i className="ri-inbox-unarchive-fill"></i></Col>
              <Col><i className="ri-cloud-fill"></i></Col>
              <Col><i className="ri-cloud-off-fill"></i></Col>
              <Col><i className="ri-attachment-fill"></i></Col>
              <Col><i className="ri-profile-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-archive-line"></i></Col>
              <Col><i className="ri-archive-drawer-line"></i></Col>
              <Col><i className="ri-at-line"></i></Col>
              <Col><i className="ri-award-line"></i></Col>
              <Col><i className="ri-medal-line"></i></Col>
              <Col><i className="ri-medal-2-line"></i></Col>
              <Col><i className="ri-bar-chart-line"></i></Col>
              <Col><i className="ri-bar-chart-horizontal-line"></i></Col>
              <Col><i className="ri-bar-chart-2-line"></i></Col>
              <Col><i className="ri-bar-chart-box-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-archive-fill"></i></Col>
              <Col><i className="ri-archive-drawer-fill"></i></Col>
              <Col><i className="ri-at-fill"></i></Col>
              <Col><i className="ri-award-fill"></i></Col>
              <Col><i className="ri-medal-fill"></i></Col>
              <Col><i className="ri-medal-2-fill"></i></Col>
              <Col><i className="ri-bar-chart-fill"></i></Col>
              <Col><i className="ri-bar-chart-horizontal-fill"></i></Col>
              <Col><i className="ri-bar-chart-2-fill"></i></Col>
              <Col><i className="ri-bar-chart-box-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-bar-chart-grouped-line"></i></Col>
              <Col><i className="ri-bubble-chart-line"></i></Col>
              <Col><i className="ri-pie-chart-line"></i></Col>
              <Col><i className="ri-pie-chart-2-line"></i></Col>
              <Col><i className="ri-pie-chart-box-line"></i></Col>
              <Col><i className="ri-donut-chart-line"></i></Col>
              <Col><i className="ri-line-chart-line"></i></Col>
              <Col><i className="ri-bookmark-line"></i></Col>
              <Col><i className="ri-bookmark-2-line"></i></Col>
              <Col><i className="ri-bookmark-3-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-bar-chart-grouped-fill"></i></Col>
              <Col><i className="ri-bubble-chart-fill"></i></Col>
              <Col><i className="ri-pie-chart-fill"></i></Col>
              <Col><i className="ri-pie-chart-2-fill"></i></Col>
              <Col><i className="ri-pie-chart-box-fill"></i></Col>
              <Col><i className="ri-donut-chart-fill"></i></Col>
              <Col><i className="ri-line-chart-fill"></i></Col>
              <Col><i className="ri-bookmark-fill"></i></Col>
              <Col><i className="ri-bookmark-2-fill"></i></Col>
              <Col><i className="ri-bookmark-3-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-briefcase-line"></i></Col>
              <Col><i className="ri-briefcase-2-line"></i></Col>
              <Col><i className="ri-briefcase-3-line"></i></Col>
              <Col><i className="ri-briefcase-4-line"></i></Col>
              <Col><i className="ri-briefcase-5-line"></i></Col>
              <Col><i className="ri-calculator-line"></i></Col>
              <Col><i className="ri-calendar-line"></i></Col>
              <Col><i className="ri-calendar-2-line"></i></Col>
              <Col><i className="ri-calendar-event-line"></i></Col>
              <Col><i className="ri-calendar-todo-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-briefcase-fill"></i></Col>
              <Col><i className="ri-briefcase-2-fill"></i></Col>
              <Col><i className="ri-briefcase-3-fill"></i></Col>
              <Col><i className="ri-briefcase-4-fill"></i></Col>
              <Col><i className="ri-briefcase-5-fill"></i></Col>
              <Col><i className="ri-calculator-fill"></i></Col>
              <Col><i className="ri-calendar-fill"></i></Col>
              <Col><i className="ri-calendar-2-fill"></i></Col>
              <Col><i className="ri-calendar-event-fill"></i></Col>
              <Col><i className="ri-calendar-todo-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-calendar-check-line"></i></Col>
              <Col><i className="ri-customer-service-line"></i></Col>
              <Col><i className="ri-customer-service-2-line"></i></Col>
              <Col><i className="ri-flag-line"></i></Col>
              <Col><i className="ri-flag-2-line"></i></Col>
              <Col><i className="ri-global-line"></i></Col>
              <Col><i className="ri-honour-line"></i></Col>
              <Col><i className="ri-links-line"></i></Col>
              <Col><i className="ri-printer-line"></i></Col>
              <Col><i className="ri-printer-cloud-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-calendar-check-fill"></i></Col>
              <Col><i className="ri-customer-service-fill"></i></Col>
              <Col><i className="ri-customer-service-2-fill"></i></Col>
              <Col><i className="ri-flag-fill"></i></Col>
              <Col><i className="ri-flag-2-fill"></i></Col>
              <Col><i className="ri-global-fill"></i></Col>
              <Col><i className="ri-honour-fill"></i></Col>
              <Col><i className="ri-links-fill"></i></Col>
              <Col><i className="ri-printer-fill"></i></Col>
              <Col><i className="ri-printer-cloud-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-record-mail-line"></i></Col>
              <Col><i className="ri-reply-line"></i></Col>
              <Col><i className="ri-reply-all-line"></i></Col>
              <Col><i className="ri-send-plane-line"></i></Col>
              <Col><i className="ri-send-plane-2-line"></i></Col>
              <Col><i className="ri-projector-line"></i></Col>
              <Col><i className="ri-projector-2-line"></i></Col>
              <Col><i className="ri-slideshow-line"></i></Col>
              <Col><i className="ri-slideshow-2-line"></i></Col>
              <Col><i className="ri-slideshow-3-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-record-mail-fill"></i></Col>
              <Col><i className="ri-reply-fill"></i></Col>
              <Col><i className="ri-reply-all-fill"></i></Col>
              <Col><i className="ri-send-plane-fill"></i></Col>
              <Col><i className="ri-send-plane-2-fill"></i></Col>
              <Col><i className="ri-projector-fill"></i></Col>
              <Col><i className="ri-projector-2-fill"></i></Col>
              <Col><i className="ri-slideshow-fill"></i></Col>
              <Col><i className="ri-slideshow-2-fill"></i></Col>
              <Col><i className="ri-slideshow-3-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-slideshow-4-line"></i></Col>
              <Col><i className="ri-window-line"></i></Col>
              <Col><i className="ri-window-2-line"></i></Col>
              <Col><i className="ri-stack-line"></i></Col>
              <Col><i className="ri-service-line"></i></Col>
              <Col><i className="ri-registered-line"></i></Col>
              <Col><i className="ri-trademark-line"></i></Col>
              <Col><i className="ri-advertisement-line"></i></Col>
              <Col><i className="ri-copyleft-line"></i></Col>
              <Col><i className="ri-copyright-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-slideshow-4-fill"></i></Col>
              <Col><i className="ri-window-fill"></i></Col>
              <Col><i className="ri-window-2-fill"></i></Col>
              <Col><i className="ri-stack-fill"></i></Col>
              <Col><i className="ri-service-fill"></i></Col>
              <Col><i className="ri-registered-fill"></i></Col>
              <Col><i className="ri-trademark-fill"></i></Col>
              <Col><i className="ri-advertisement-fill"></i></Col>
              <Col><i className="ri-copyleft-fill"></i></Col>
              <Col><i className="ri-copyright-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-creative-commons-line"></i></Col>
              <Col><i className="ri-creative-commons-by-line"></i></Col>
              <Col><i className="ri-creative-commons-nc-line"></i></Col>
              <Col><i className="ri-creative-commons-nd-line"></i></Col>
              <Col><i className="ri-creative-commons-sa-line"></i></Col>
              <Col><i className="ri-creative-commons-zero-line"></i></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <div className="w-100"></div>
              <Col><i className="ri-creative-commons-fill"></i></Col>
              <Col><i className="ri-creative-commons-by-fill"></i></Col>
              <Col><i className="ri-creative-commons-nc-fill"></i></Col>
              <Col><i className="ri-creative-commons-nd-fill"></i></Col>
              <Col><i className="ri-creative-commons-sa-fill"></i></Col>
              <Col><i className="ri-creative-commons-zero-fill"></i></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
            </Row>
          </div>

          <br /><br /><br />

          <h5 id="section3" className="main-subtitle">Communication</h5>

          <div className="icon-group">
            <Row className="gx-1 gy-2">
              <Col><i className="ri-chat-1-line"></i></Col>
              <Col><i className="ri-chat-2-line"></i></Col>
              <Col><i className="ri-chat-3-line"></i></Col>
              <Col><i className="ri-chat-4-line"></i></Col>
              <Col><i className="ri-message-line"></i></Col>
              <Col><i className="ri-message-2-line"></i></Col>
              <Col><i className="ri-message-3-line"></i></Col>
              <Col><i className="ri-chat-check-line"></i></Col>
              <Col><i className="ri-chat-delete-line"></i></Col>
              <Col><i className="ri-chat-forward-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-chat-1-fill"></i></Col>
              <Col><i className="ri-chat-2-fill"></i></Col>
              <Col><i className="ri-chat-3-fill"></i></Col>
              <Col><i className="ri-chat-4-fill"></i></Col>
              <Col><i className="ri-message-fill"></i></Col>
              <Col><i className="ri-message-2-fill"></i></Col>
              <Col><i className="ri-message-3-fill"></i></Col>
              <Col><i className="ri-chat-check-fill"></i></Col>
              <Col><i className="ri-chat-delete-fill"></i></Col>
              <Col><i className="ri-chat-forward-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-chat-upload-line"></i></Col>
              <Col><i className="ri-chat-download-line"></i></Col>
              <Col><i className="ri-chat-new-line"></i></Col>
              <Col><i className="ri-chat-settings-line"></i></Col>
              <Col><i className="ri-chat-smile-line"></i></Col>
              <Col><i className="ri-chat-smile-2-line"></i></Col>
              <Col><i className="ri-chat-smile-3-line"></i></Col>
              <Col><i className="ri-chat-heart-line"></i></Col>
              <Col><i className="ri-chat-off-line"></i></Col>
              <Col><i className="ri-feedback-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-chat-upload-fill"></i></Col>
              <Col><i className="ri-chat-download-fill"></i></Col>
              <Col><i className="ri-chat-new-fill"></i></Col>
              <Col><i className="ri-chat-settings-fill"></i></Col>
              <Col><i className="ri-chat-smile-fill"></i></Col>
              <Col><i className="ri-chat-smile-2-fill"></i></Col>
              <Col><i className="ri-chat-smile-3-fill"></i></Col>
              <Col><i className="ri-chat-heart-fill"></i></Col>
              <Col><i className="ri-chat-off-fill"></i></Col>
              <Col><i className="ri-feedback-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-discuss-line"></i></Col>
              <Col><i className="ri-question-answer-line"></i></Col>
              <Col><i className="ri-questionnaire-line"></i></Col>
              <Col><i className="ri-video-chat-line"></i></Col>
              <Col><i className="ri-chat-voice-line"></i></Col>
              <Col><i className="ri-chat-quote-line"></i></Col>
              <Col><i className="ri-chat-follow-up-line"></i></Col>
              <Col><i className="ri-chat-poll-line"></i></Col>
              <Col><i className="ri-chat-history-line"></i></Col>
              <Col><i className="ri-chat-private-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-discuss-fill"></i></Col>
              <Col><i className="ri-question-answer-fill"></i></Col>
              <Col><i className="ri-questionnaire-fill"></i></Col>
              <Col><i className="ri-video-chat-fill"></i></Col>
              <Col><i className="ri-chat-voice-fill"></i></Col>
              <Col><i className="ri-chat-quote-fill"></i></Col>
              <Col><i className="ri-chat-follow-up-fill"></i></Col>
              <Col><i className="ri-chat-poll-fill"></i></Col>
              <Col><i className="ri-chat-history-fill"></i></Col>
              <Col><i className="ri-chat-private-fill"></i></Col>
            </Row>
          </div>

          <br /><br /><br />

          <h5 id="section4" className="main-subtitle">Design</h5>

          <div className="icon-group">
            <Row className="gx-1 gy-2">
              <Col><i className="ri-pencil-line"></i></Col>
              <Col><i className="ri-edit-line"></i></Col>
              <Col><i className="ri-edit-2-line"></i></Col>
              <Col><i className="ri-ball-pen-line"></i></Col>
              <Col><i className="ri-quill-pen-line"></i></Col>
              <Col><i className="ri-pen-nib-line"></i></Col>
              <Col><i className="ri-ink-bottle-line"></i></Col>
              <Col><i className="ri-mark-pen-line"></i></Col>
              <Col><i className="ri-markup-line"></i></Col>
              <Col><i className="ri-edit-box-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-pencil-fill"></i></Col>
              <Col><i className="ri-edit-fill"></i></Col>
              <Col><i className="ri-edit-2-fill"></i></Col>
              <Col><i className="ri-ball-pen-fill"></i></Col>
              <Col><i className="ri-quill-pen-fill"></i></Col>
              <Col><i className="ri-pen-nib-fill"></i></Col>
              <Col><i className="ri-ink-bottle-fill"></i></Col>
              <Col><i className="ri-mark-pen-fill"></i></Col>
              <Col><i className="ri-markup-fill"></i></Col>
              <Col><i className="ri-edit-box-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-edit-circle-line"></i></Col>
              <Col><i className="ri-sip-line"></i></Col>
              <Col><i className="ri-brush-line"></i></Col>
              <Col><i className="ri-brush-2-line"></i></Col>
              <Col><i className="ri-brush-3-line"></i></Col>
              <Col><i className="ri-brush-4-line"></i></Col>
              <Col><i className="ri-paint-brush-line"></i></Col>
              <Col><i className="ri-contrast-line"></i></Col>
              <Col><i className="ri-contrast-2-line"></i></Col>
              <Col><i className="ri-drop-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-edit-circle-fill"></i></Col>
              <Col><i className="ri-sip-fill"></i></Col>
              <Col><i className="ri-brush-fill"></i></Col>
              <Col><i className="ri-brush-2-fill"></i></Col>
              <Col><i className="ri-brush-3-fill"></i></Col>
              <Col><i className="ri-brush-4-fill"></i></Col>
              <Col><i className="ri-paint-brush-fill"></i></Col>
              <Col><i className="ri-contrast-fill"></i></Col>
              <Col><i className="ri-contrast-2-fill"></i></Col>
              <Col><i className="ri-drop-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-blur-off-line"></i></Col>
              <Col><i className="ri-contrast-drop-line"></i></Col>
              <Col><i className="ri-contrast-drop-2-line"></i></Col>
              <Col><i className="ri-compasses-line"></i></Col>
              <Col><i className="ri-compasses-2-line"></i></Col>
              <Col><i className="ri-scissors-line"></i></Col>
              <Col><i className="ri-scissors-cut-line"></i></Col>
              <Col><i className="ri-scissors-2-line"></i></Col>
              <Col><i className="ri-slice-line"></i></Col>
              <Col><i className="ri-eraser-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-blur-off-fill"></i></Col>
              <Col><i className="ri-contrast-drop-fill"></i></Col>
              <Col><i className="ri-contrast-drop-2-fill"></i></Col>
              <Col><i className="ri-compasses-fill"></i></Col>
              <Col><i className="ri-compasses-2-fill"></i></Col>
              <Col><i className="ri-scissors-fill"></i></Col>
              <Col><i className="ri-scissors-cut-fill"></i></Col>
              <Col><i className="ri-scissors-2-fill"></i></Col>
              <Col><i className="ri-slice-fill"></i></Col>
              <Col><i className="ri-eraser-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-ruler-line"></i></Col>
              <Col><i className="ri-ruler-2-line"></i></Col>
              <Col><i className="ri-pencil-ruler-line"></i></Col>
              <Col><i className="ri-pencil-ruler-2-line"></i></Col>
              <Col><i className="ri-t-box-line"></i></Col>
              <Col><i className="ri-input-method-line"></i></Col>
              <Col><i className="ri-artboard-line"></i></Col>
              <Col><i className="ri-artboard-2-line"></i></Col>
              <Col><i className="ri-crop-line"></i></Col>
              <Col><i className="ri-crop-2-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-ruler-fill"></i></Col>
              <Col><i className="ri-ruler-2-fill"></i></Col>
              <Col><i className="ri-pencil-ruler-fill"></i></Col>
              <Col><i className="ri-pencil-ruler-2-fill"></i></Col>
              <Col><i className="ri-t-box-fill"></i></Col>
              <Col><i className="ri-input-method-fill"></i></Col>
              <Col><i className="ri-artboard-fill"></i></Col>
              <Col><i className="ri-artboard-2-fill"></i></Col>
              <Col><i className="ri-crop-fill"></i></Col>
              <Col><i className="ri-crop-2-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-screenshot-line"></i></Col>
              <Col><i className="ri-screenshot-2-line"></i></Col>
              <Col><i className="ri-drag-move-line"></i></Col>
              <Col><i className="ri-drag-move-2-line"></i></Col>
              <Col><i className="ri-focus-line"></i></Col>
              <Col><i className="ri-focus-2-line"></i></Col>
              <Col><i className="ri-focus-3-line"></i></Col>
              <Col><i className="ri-paint-line"></i></Col>
              <Col><i className="ri-palette-line"></i></Col>
              <Col><i className="ri-pantone-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-screenshot-fill"></i></Col>
              <Col><i className="ri-screenshot-2-fill"></i></Col>
              <Col><i className="ri-drag-move-fill"></i></Col>
              <Col><i className="ri-drag-move-2-fill"></i></Col>
              <Col><i className="ri-focus-fill"></i></Col>
              <Col><i className="ri-focus-2-fill"></i></Col>
              <Col><i className="ri-focus-3-fill"></i></Col>
              <Col><i className="ri-paint-fill"></i></Col>
              <Col><i className="ri-palette-fill"></i></Col>
              <Col><i className="ri-pantone-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-shape-line"></i></Col>
              <Col><i className="ri-shape-2-line"></i></Col>
              <Col><i className="ri-magic-line"></i></Col>
              <Col><i className="ri-anticlockwise-line"></i></Col>
              <Col><i className="ri-anticlockwise-2-line"></i></Col>
              <Col><i className="ri-clockwise-line"></i></Col>
              <Col><i className="ri-clockwise-2-line"></i></Col>
              <Col><i className="ri-hammer-line"></i></Col>
              <Col><i className="ri-tools-line"></i></Col>
              <Col><i className="ri-drag-drop-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-shape-fill"></i></Col>
              <Col><i className="ri-shape-2-fill"></i></Col>
              <Col><i className="ri-magic-fill"></i></Col>
              <Col><i className="ri-anticlockwise-fill"></i></Col>
              <Col><i className="ri-anticlockwise-2-fill"></i></Col>
              <Col><i className="ri-clockwise-fill"></i></Col>
              <Col><i className="ri-clockwise-2-fill"></i></Col>
              <Col><i className="ri-hammer-fill"></i></Col>
              <Col><i className="ri-tools-fill"></i></Col>
              <Col><i className="ri-drag-drop-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-table-line"></i></Col>
              <Col><i className="ri-table-alt-line"></i></Col>
              <Col><i className="ri-layout-line"></i></Col>
              <Col><i className="ri-layout-2-line"></i></Col>
              <Col><i className="ri-layout-3-line"></i></Col>
              <Col><i className="ri-layout-4-line"></i></Col>
              <Col><i className="ri-layout-5-line"></i></Col>
              <Col><i className="ri-layout-6-line"></i></Col>
              <Col><i className="ri-layout-column-line"></i></Col>
              <Col><i className="ri-layout-row-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-table-fill"></i></Col>
              <Col><i className="ri-table-alt-fill"></i></Col>
              <Col><i className="ri-layout-fill"></i></Col>
              <Col><i className="ri-layout-2-fill"></i></Col>
              <Col><i className="ri-layout-3-fill"></i></Col>
              <Col><i className="ri-layout-4-fill"></i></Col>
              <Col><i className="ri-layout-5-fill"></i></Col>
              <Col><i className="ri-layout-6-fill"></i></Col>
              <Col><i className="ri-layout-column-fill"></i></Col>
              <Col><i className="ri-layout-row-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-collage-line"></i></Col>
              <Col><i className="ri-grid-line"></i></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <div className="w-100"></div>
              <Col><i className="ri-collage-fill"></i></Col>
              <Col><i className="ri-grid-fill"></i></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
            </Row>
          </div>

          <br /><br /><br />

          <h5 id="section5" className="main-subtitle">Development</h5>

          <div className="icon-group">
            <Row className="gx-1 gy-2">
              <Col><i className="ri-bug-line"></i></Col>
              <Col><i className="ri-bug-2-line"></i></Col>
              <Col><i className="ri-code-line"></i></Col>
              <Col><i className="ri-code-s-line"></i></Col>
              <Col><i className="ri-code-s-slash-line"></i></Col>
              <Col><i className="ri-code-box-line"></i></Col>
              <Col><i className="ri-terminal-box-line"></i></Col>
              <Col><i className="ri-terminal-line"></i></Col>
              <Col><i className="ri-terminal-window-line"></i></Col>
              <Col><i className="ri-parentheses-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-bug-fill"></i></Col>
              <Col><i className="ri-bug-2-fill"></i></Col>
              <Col><i className="ri-code-fill"></i></Col>
              <Col><i className="ri-code-s-fill"></i></Col>
              <Col><i className="ri-code-s-slash-fill"></i></Col>
              <Col><i className="ri-code-box-fill"></i></Col>
              <Col><i className="ri-terminal-box-fill"></i></Col>
              <Col><i className="ri-terminal-fill"></i></Col>
              <Col><i className="ri-terminal-window-fill"></i></Col>
              <Col><i className="ri-parentheses-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-brackets-line"></i></Col>
              <Col><i className="ri-braces-line"></i></Col>
              <Col><i className="ri-command-line"></i></Col>
              <Col><i className="ri-cursor-line"></i></Col>
              <Col><i className="ri-git-commit-line"></i></Col>
              <Col><i className="ri-git-pull-request-line"></i></Col>
              <Col><i className="ri-git-merge-line"></i></Col>
              <Col><i className="ri-git-branch-line"></i></Col>
              <Col><i className="ri-git-repository-line"></i></Col>
              <Col><i className="ri-git-repository-commits-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-brackets-fill"></i></Col>
              <Col><i className="ri-braces-fill"></i></Col>
              <Col><i className="ri-command-fill"></i></Col>
              <Col><i className="ri-cursor-fill"></i></Col>
              <Col><i className="ri-git-commit-fill"></i></Col>
              <Col><i className="ri-git-pull-request-fill"></i></Col>
              <Col><i className="ri-git-merge-fill"></i></Col>
              <Col><i className="ri-git-branch-fill"></i></Col>
              <Col><i className="ri-git-repository-fill"></i></Col>
              <Col><i className="ri-git-repository-commits-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-git-repository-private-line"></i></Col>
              <Col><i className="ri-html5-line"></i></Col>
              <Col><i className="ri-css3-line"></i></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <div className="w-100"></div>
              <Col><i className="ri-git-repository-private-fill"></i></Col>
              <Col><i className="ri-html5-fill"></i></Col>
              <Col><i className="ri-css3-fill"></i></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
            </Row>
          </div>

          <br /><br /><br />

          <h5 id="section6" className="main-subtitle">Device</h5>

          <div className="icon-group">
            <Row className="gx-1 gy-2">
              <Col><i className="ri-tv-line"></i></Col>
              <Col><i className="ri-tv-2-line"></i></Col>
              <Col><i className="ri-computer-line"></i></Col>
              <Col><i className="ri-mac-line"></i></Col>
              <Col><i className="ri-macbook-line"></i></Col>
              <Col><i className="ri-cellphone-line"></i></Col>
              <Col><i className="ri-smartphone-line"></i></Col>
              <Col><i className="ri-tablet-line"></i></Col>
              <Col><i className="ri-device-line"></i></Col>
              <Col><i className="ri-phone-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-tv-fill"></i></Col>
              <Col><i className="ri-tv-2-fill"></i></Col>
              <Col><i className="ri-computer-fill"></i></Col>
              <Col><i className="ri-mac-fill"></i></Col>
              <Col><i className="ri-macbook-fill"></i></Col>
              <Col><i className="ri-cellphone-fill"></i></Col>
              <Col><i className="ri-smartphone-fill"></i></Col>
              <Col><i className="ri-tablet-fill"></i></Col>
              <Col><i className="ri-device-fill"></i></Col>
              <Col><i className="ri-phone-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-database-line"></i></Col>
              <Col><i className="ri-database-2-line"></i></Col>
              <Col><i className="ri-server-line"></i></Col>
              <Col><i className="ri-hard-drive-line"></i></Col>
              <Col><i className="ri-hard-drive-2-line"></i></Col>
              <Col><i className="ri-install-line"></i></Col>
              <Col><i className="ri-uninstall-line"></i></Col>
              <Col><i className="ri-save-line"></i></Col>
              <Col><i className="ri-save-2-line"></i></Col>
              <Col><i className="ri-save-3-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-database-fill"></i></Col>
              <Col><i className="ri-database-2-fill"></i></Col>
              <Col><i className="ri-server-fill"></i></Col>
              <Col><i className="ri-hard-drive-fill"></i></Col>
              <Col><i className="ri-hard-drive-2-fill"></i></Col>
              <Col><i className="ri-install-fill"></i></Col>
              <Col><i className="ri-uninstall-fill"></i></Col>
              <Col><i className="ri-save-fill"></i></Col>
              <Col><i className="ri-save-2-fill"></i></Col>
              <Col><i className="ri-save-3-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-sd-card-line"></i></Col>
              <Col><i className="ri-sd-card-mini-line"></i></Col>
              <Col><i className="ri-sim-card-line"></i></Col>
              <Col><i className="ri-sim-card-2-line"></i></Col>
              <Col><i className="ri-dual-sim-1-line"></i></Col>
              <Col><i className="ri-dual-sim-2-line"></i></Col>
              <Col><i className="ri-u-disk-line"></i></Col>
              <Col><i className="ri-battery-line"></i></Col>
              <Col><i className="ri-battery-charge-line"></i></Col>
              <Col><i className="ri-battery-low-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-sd-card-fill"></i></Col>
              <Col><i className="ri-sd-card-mini-fill"></i></Col>
              <Col><i className="ri-sim-card-fill"></i></Col>
              <Col><i className="ri-sim-card-2-fill"></i></Col>
              <Col><i className="ri-dual-sim-1-fill"></i></Col>
              <Col><i className="ri-dual-sim-2-fill"></i></Col>
              <Col><i className="ri-u-disk-fill"></i></Col>
              <Col><i className="ri-battery-fill"></i></Col>
              <Col><i className="ri-battery-charge-fill"></i></Col>
              <Col><i className="ri-battery-low-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-battery-2-line"></i></Col>
              <Col><i className="ri-battery-2-charge-line"></i></Col>
              <Col><i className="ri-battery-saver-line"></i></Col>
              <Col><i className="ri-battery-share-line"></i></Col>
              <Col><i className="ri-cast-line"></i></Col>
              <Col><i className="ri-airplay-line"></i></Col>
              <Col><i className="ri-cpu-line"></i></Col>
              <Col><i className="ri-gradienter-line"></i></Col>
              <Col><i className="ri-keyboard-line"></i></Col>
              <Col><i className="ri-keyboard-box-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-battery-2-fill"></i></Col>
              <Col><i className="ri-battery-2-charge-fill"></i></Col>
              <Col><i className="ri-battery-saver-fill"></i></Col>
              <Col><i className="ri-battery-share-fill"></i></Col>
              <Col><i className="ri-cast-fill"></i></Col>
              <Col><i className="ri-airplay-fill"></i></Col>
              <Col><i className="ri-cpu-fill"></i></Col>
              <Col><i className="ri-gradienter-fill"></i></Col>
              <Col><i className="ri-keyboard-fill"></i></Col>
              <Col><i className="ri-keyboard-box-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-mouse-line"></i></Col>
              <Col><i className="ri-sensor-line"></i></Col>
              <Col><i className="ri-router-line"></i></Col>
              <Col><i className="ri-radar-line"></i></Col>
              <Col><i className="ri-gamepad-line"></i></Col>
              <Col><i className="ri-remote-control-line"></i></Col>
              <Col><i className="ri-remote-control-2-line"></i></Col>
              <Col><i className="ri-device-recover-line"></i></Col>
              <Col><i className="ri-hotspot-line"></i></Col>
              <Col><i className="ri-phone-find-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-mouse-fill"></i></Col>
              <Col><i className="ri-sensor-fill"></i></Col>
              <Col><i className="ri-router-fill"></i></Col>
              <Col><i className="ri-radar-fill"></i></Col>
              <Col><i className="ri-gamepad-fill"></i></Col>
              <Col><i className="ri-remote-control-fill"></i></Col>
              <Col><i className="ri-remote-control-2-fill"></i></Col>
              <Col><i className="ri-device-recover-fill"></i></Col>
              <Col><i className="ri-hotspot-fill"></i></Col>
              <Col><i className="ri-phone-find-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-phone-lock-line"></i></Col>
              <Col><i className="ri-rotate-lock-line"></i></Col>
              <Col><i className="ri-restart-line"></i></Col>
              <Col><i className="ri-shut-down-line"></i></Col>
              <Col><i className="ri-fingerprint-line"></i></Col>
              <Col><i className="ri-fingerprint-2-line"></i></Col>
              <Col><i className="ri-barcode-line"></i></Col>
              <Col><i className="ri-barcode-box-line"></i></Col>
              <Col><i className="ri-qr-code-line"></i></Col>
              <Col><i className="ri-qr-scan-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-phone-lock-fill"></i></Col>
              <Col><i className="ri-rotate-lock-fill"></i></Col>
              <Col><i className="ri-restart-fill"></i></Col>
              <Col><i className="ri-shut-down-fill"></i></Col>
              <Col><i className="ri-fingerprint-fill"></i></Col>
              <Col><i className="ri-fingerprint-2-fill"></i></Col>
              <Col><i className="ri-barcode-fill"></i></Col>
              <Col><i className="ri-barcode-box-fill"></i></Col>
              <Col><i className="ri-qr-code-fill"></i></Col>
              <Col><i className="ri-qr-scan-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-qr-scan-2-line"></i></Col>
              <Col><i className="ri-scan-line"></i></Col>
              <Col><i className="ri-scan-2-line"></i></Col>
              <Col><i className="ri-rss-line"></i></Col>
              <Col><i className="ri-gps-line"></i></Col>
              <Col><i className="ri-base-station-line"></i></Col>
              <Col><i className="ri-bluetooth-line"></i></Col>
              <Col><i className="ri-bluetooth-connect-line"></i></Col>
              <Col><i className="ri-wifi-line"></i></Col>
              <Col><i className="ri-wifi-off-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-qr-scan-2-fill"></i></Col>
              <Col><i className="ri-scan-fill"></i></Col>
              <Col><i className="ri-scan-2-fill"></i></Col>
              <Col><i className="ri-rss-fill"></i></Col>
              <Col><i className="ri-gps-fill"></i></Col>
              <Col><i className="ri-base-station-fill"></i></Col>
              <Col><i className="ri-bluetooth-fill"></i></Col>
              <Col><i className="ri-bluetooth-connect-fill"></i></Col>
              <Col><i className="ri-wifi-fill"></i></Col>
              <Col><i className="ri-wifi-off-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-signal-wifi-line"></i></Col>
              <Col><i className="ri-signal-wifi-1-line"></i></Col>
              <Col><i className="ri-signal-wifi-2-line"></i></Col>
              <Col><i className="ri-signal-wifi-3-line"></i></Col>
              <Col><i className="ri-signal-wifi-error-line"></i></Col>
              <Col><i className="ri-signal-wifi-off-line"></i></Col>
              <Col><i className="ri-wireless-charging-line"></i></Col>
              <Col><i className="ri-dashboard-2-line"></i></Col>
              <Col><i className="ri-dashboard-3-line"></i></Col>
              <Col><i className="ri-usb-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-signal-wifi-fill"></i></Col>
              <Col><i className="ri-signal-wifi-1-fill"></i></Col>
              <Col><i className="ri-signal-wifi-2-fill"></i></Col>
              <Col><i className="ri-signal-wifi-3-fill"></i></Col>
              <Col><i className="ri-signal-wifi-error-fill"></i></Col>
              <Col><i className="ri-signal-wifi-off-fill"></i></Col>
              <Col><i className="ri-wireless-charging-fill"></i></Col>
              <Col><i className="ri-dashboard-2-fill"></i></Col>
              <Col><i className="ri-dashboard-3-fill"></i></Col>
              <Col><i className="ri-usb-fill"></i></Col>
            </Row>
          </div>

          <br /><br /><br />

          <h5 id="section7" className="main-subtitle">Document</h5>

          <div className="icon-group">
            <Row className="gx-1 gy-2">
              <Col><i className="ri-file-line"></i></Col>
              <Col><i className="ri-file-2-line"></i></Col>
              <Col><i className="ri-file-3-line"></i></Col>
              <Col><i className="ri-file-4-line"></i></Col>
              <Col><i className="ri-sticky-note-line"></i></Col>
              <Col><i className="ri-sticky-note-2-line"></i></Col>
              <Col><i className="ri-file-edit-line"></i></Col>
              <Col><i className="ri-draft-line"></i></Col>
              <Col><i className="ri-file-paper-line"></i></Col>
              <Col><i className="ri-file-paper-2-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-file-fill"></i></Col>
              <Col><i className="ri-file-2-fill"></i></Col>
              <Col><i className="ri-file-3-fill"></i></Col>
              <Col><i className="ri-file-4-fill"></i></Col>
              <Col><i className="ri-sticky-note-fill"></i></Col>
              <Col><i className="ri-sticky-note-2-fill"></i></Col>
              <Col><i className="ri-file-edit-fill"></i></Col>
              <Col><i className="ri-draft-fill"></i></Col>
              <Col><i className="ri-file-paper-fill"></i></Col>
              <Col><i className="ri-file-paper-2-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-file-text-line"></i></Col>
              <Col><i className="ri-file-list-line"></i></Col>
              <Col><i className="ri-file-list-2-line"></i></Col>
              <Col><i className="ri-file-list-3-line"></i></Col>
              <Col><i className="ri-bill-line"></i></Col>
              <Col><i className="ri-file-copy-line"></i></Col>
              <Col><i className="ri-file-copy-2-line"></i></Col>
              <Col><i className="ri-clipboard-line"></i></Col>
              <Col><i className="ri-survey-line"></i></Col>
              <Col><i className="ri-article-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-file-text-fill"></i></Col>
              <Col><i className="ri-file-list-fill"></i></Col>
              <Col><i className="ri-file-list-2-fill"></i></Col>
              <Col><i className="ri-file-list-3-fill"></i></Col>
              <Col><i className="ri-bill-fill"></i></Col>
              <Col><i className="ri-file-copy-fill"></i></Col>
              <Col><i className="ri-file-copy-2-fill"></i></Col>
              <Col><i className="ri-clipboard-fill"></i></Col>
              <Col><i className="ri-survey-fill"></i></Col>
              <Col><i className="ri-article-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-newspaper-line"></i></Col>
              <Col><i className="ri-file-zip-line"></i></Col>
              <Col><i className="ri-file-mark-line"></i></Col>
              <Col><i className="ri-task-line"></i></Col>
              <Col><i className="ri-todo-line"></i></Col>
              <Col><i className="ri-book-line"></i></Col>
              <Col><i className="ri-book-mark-line"></i></Col>
              <Col><i className="ri-book-2-line"></i></Col>
              <Col><i className="ri-book-3-line"></i></Col>
              <Col><i className="ri-book-open-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-newspaper-fill"></i></Col>
              <Col><i className="ri-file-zip-fill"></i></Col>
              <Col><i className="ri-file-mark-fill"></i></Col>
              <Col><i className="ri-task-fill"></i></Col>
              <Col><i className="ri-todo-fill"></i></Col>
              <Col><i className="ri-book-fill"></i></Col>
              <Col><i className="ri-book-mark-fill"></i></Col>
              <Col><i className="ri-book-2-fill"></i></Col>
              <Col><i className="ri-book-3-fill"></i></Col>
              <Col><i className="ri-book-open-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-book-read-line"></i></Col>
              <Col><i className="ri-contacts-book-line"></i></Col>
              <Col><i className="ri-contacts-book-2-line"></i></Col>
              <Col><i className="ri-contacts-book-upload-line"></i></Col>
              <Col><i className="ri-booklet-line"></i></Col>
              <Col><i className="ri-file-code-line"></i></Col>
              <Col><i className="ri-file-pdf-line"></i></Col>
              <Col><i className="ri-file-word-line"></i></Col>
              <Col><i className="ri-file-ppt-line"></i></Col>
              <Col><i className="ri-file-excel-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-book-read-fill"></i></Col>
              <Col><i className="ri-contacts-book-fill"></i></Col>
              <Col><i className="ri-contacts-book-2-fill"></i></Col>
              <Col><i className="ri-contacts-book-upload-fill"></i></Col>
              <Col><i className="ri-booklet-fill"></i></Col>
              <Col><i className="ri-file-code-fill"></i></Col>
              <Col><i className="ri-file-pdf-fill"></i></Col>
              <Col><i className="ri-file-word-fill"></i></Col>
              <Col><i className="ri-file-ppt-fill"></i></Col>
              <Col><i className="ri-file-excel-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-file-word-2-line"></i></Col>
              <Col><i className="ri-file-ppt-2-line"></i></Col>
              <Col><i className="ri-file-excel-2-line"></i></Col>
              <Col><i className="ri-file-hwp-line"></i></Col>
              <Col><i className="ri-keynote-line"></i></Col>
              <Col><i className="ri-numbers-line"></i></Col>
              <Col><i className="ri-pages-line"></i></Col>
              <Col><i className="ri-file-search-line"></i></Col>
              <Col><i className="ri-file-add-line"></i></Col>
              <Col><i className="ri-file-reduce-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-file-word-2-fill"></i></Col>
              <Col><i className="ri-file-ppt-2-fill"></i></Col>
              <Col><i className="ri-file-excel-2-fill"></i></Col>
              <Col><i className="ri-file-hwp-fill"></i></Col>
              <Col><i className="ri-keynote-fill"></i></Col>
              <Col><i className="ri-numbers-fill"></i></Col>
              <Col><i className="ri-pages-fill"></i></Col>
              <Col><i className="ri-file-search-fill"></i></Col>
              <Col><i className="ri-file-add-fill"></i></Col>
              <Col><i className="ri-file-reduce-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-file-settings-line"></i></Col>
              <Col><i className="ri-file-upload-line"></i></Col>
              <Col><i className="ri-file-transfer-line"></i></Col>
              <Col><i className="ri-file-download-line"></i></Col>
              <Col><i className="ri-file-lock-line"></i></Col>
              <Col><i className="ri-file-chart-line"></i></Col>
              <Col><i className="ri-file-chart-2-line"></i></Col>
              <Col><i className="ri-file-music-line"></i></Col>
              <Col><i className="ri-file-gif-line"></i></Col>
              <Col><i className="ri-file-forbid-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-file-settings-fill"></i></Col>
              <Col><i className="ri-file-upload-fill"></i></Col>
              <Col><i className="ri-file-transfer-fill"></i></Col>
              <Col><i className="ri-file-download-fill"></i></Col>
              <Col><i className="ri-file-lock-fill"></i></Col>
              <Col><i className="ri-file-chart-fill"></i></Col>
              <Col><i className="ri-file-chart-2-fill"></i></Col>
              <Col><i className="ri-file-music-fill"></i></Col>
              <Col><i className="ri-file-gif-fill"></i></Col>
              <Col><i className="ri-file-forbid-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-file-info-line"></i></Col>
              <Col><i className="ri-file-warning-line"></i></Col>
              <Col><i className="ri-file-unknow-line"></i></Col>
              <Col><i className="ri-file-user-line"></i></Col>
              <Col><i className="ri-file-shield-line"></i></Col>
              <Col><i className="ri-file-shield-2-line"></i></Col>
              <Col><i className="ri-file-damage-line"></i></Col>
              <Col><i className="ri-file-history-line"></i></Col>
              <Col><i className="ri-file-shred-line"></i></Col>
              <Col><i className="ri-file-cloud-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-file-info-fill"></i></Col>
              <Col><i className="ri-file-warning-fill"></i></Col>
              <Col><i className="ri-file-unknow-fill"></i></Col>
              <Col><i className="ri-file-user-fill"></i></Col>
              <Col><i className="ri-file-shield-fill"></i></Col>
              <Col><i className="ri-file-shield-2-fill"></i></Col>
              <Col><i className="ri-file-damage-fill"></i></Col>
              <Col><i className="ri-file-history-fill"></i></Col>
              <Col><i className="ri-file-shred-fill"></i></Col>
              <Col><i className="ri-file-cloud-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-folder-line"></i></Col>
              <Col><i className="ri-folder-2-line"></i></Col>
              <Col><i className="ri-folder-3-line"></i></Col>
              <Col><i className="ri-folder-4-line"></i></Col>
              <Col><i className="ri-folder-5-line"></i></Col>
              <Col><i className="ri-folders-line"></i></Col>
              <Col><i className="ri-folder-add-line"></i></Col>
              <Col><i className="ri-folder-reduce-line"></i></Col>
              <Col><i className="ri-folder-settings-line"></i></Col>
              <Col><i className="ri-folder-upload-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-folder-fill"></i></Col>
              <Col><i className="ri-folder-2-fill"></i></Col>
              <Col><i className="ri-folder-3-fill"></i></Col>
              <Col><i className="ri-folder-4-fill"></i></Col>
              <Col><i className="ri-folder-5-fill"></i></Col>
              <Col><i className="ri-folders-fill"></i></Col>
              <Col><i className="ri-folder-add-fill"></i></Col>
              <Col><i className="ri-folder-reduce-fill"></i></Col>
              <Col><i className="ri-folder-settings-fill"></i></Col>
              <Col><i className="ri-folder-upload-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-folder-transfer-line"></i></Col>
              <Col><i className="ri-folder-download-line"></i></Col>
              <Col><i className="ri-folder-lock-line"></i></Col>
              <Col><i className="ri-folder-chart-line"></i></Col>
              <Col><i className="ri-folder-chart-2-line"></i></Col>
              <Col><i className="ri-folder-music-line"></i></Col>
              <Col><i className="ri-folder-forbid-line"></i></Col>
              <Col><i className="ri-folder-info-line"></i></Col>
              <Col><i className="ri-folder-warning-line"></i></Col>
              <Col><i className="ri-folder-unknow-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-folder-transfer-fill"></i></Col>
              <Col><i className="ri-folder-download-fill"></i></Col>
              <Col><i className="ri-folder-lock-fill"></i></Col>
              <Col><i className="ri-folder-chart-fill"></i></Col>
              <Col><i className="ri-folder-chart-2-fill"></i></Col>
              <Col><i className="ri-folder-music-fill"></i></Col>
              <Col><i className="ri-folder-forbid-fill"></i></Col>
              <Col><i className="ri-folder-info-fill"></i></Col>
              <Col><i className="ri-folder-warning-fill"></i></Col>
              <Col><i className="ri-folder-unknow-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-folder-user-line"></i></Col>
              <Col><i className="ri-folder-shield-line"></i></Col>
              <Col><i className="ri-folder-shield-2-line"></i></Col>
              <Col><i className="ri-folder-shared-line"></i></Col>
              <Col><i className="ri-folder-received-line"></i></Col>
              <Col><i className="ri-folder-open-line"></i></Col>
              <Col><i className="ri-folder-keyhole-line"></i></Col>
              <Col><i className="ri-folder-zip-line"></i></Col>
              <Col><i className="ri-folder-history-line"></i></Col>
              <Col><i className="ri-markdown-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-folder-user-fill"></i></Col>
              <Col><i className="ri-folder-shield-fill"></i></Col>
              <Col><i className="ri-folder-shield-2-fill"></i></Col>
              <Col><i className="ri-folder-shared-fill"></i></Col>
              <Col><i className="ri-folder-received-fill"></i></Col>
              <Col><i className="ri-folder-open-fill"></i></Col>
              <Col><i className="ri-folder-keyhole-fill"></i></Col>
              <Col><i className="ri-folder-zip-fill"></i></Col>
              <Col><i className="ri-folder-history-fill"></i></Col>
              <Col><i className="ri-markdown-fill"></i></Col>
            </Row>
          </div>

          <br /><br /><br />

          <h5 id="section8" className="main-subtitle">Editor</h5>

          <div className="icon-group">
            <Row className="gx-1 gy-2">
              <Col><i className="ri-bold"></i></Col>
              <Col><i className="ri-italic"></i></Col>
              <Col><i className="ri-heading"></i></Col>
              <Col><i className="ri-text"></i></Col>
              <Col><i className="ri-font-color"></i></Col>
              <Col><i className="ri-font-size"></i></Col>
              <Col><i className="ri-font-size-2"></i></Col>
              <Col><i className="ri-underline"></i></Col>
              <Col><i className="ri-emphasis"></i></Col>
              <Col><i className="ri-emphasis-cn"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-strikethrough"></i></Col>
              <Col><i className="ri-strikethrough-2"></i></Col>
              <Col><i className="ri-format-clear"></i></Col>
              <Col><i className="ri-align-left"></i></Col>
              <Col><i className="ri-align-center"></i></Col>
              <Col><i className="ri-align-right"></i></Col>
              <Col><i className="ri-align-justify"></i></Col>
              <Col><i className="ri-align-top"></i></Col>
              <Col><i className="ri-align-vertically"></i></Col>
              <Col><i className="ri-align-bottom"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-list-check"></i></Col>
              <Col><i className="ri-list-check-2"></i></Col>
              <Col><i className="ri-list-ordered"></i></Col>
              <Col><i className="ri-list-unordered"></i></Col>
              <Col><i className="ri-indent-decrease"></i></Col>
              <Col><i className="ri-indent-increase"></i></Col>
              <Col><i className="ri-line-height"></i></Col>
              <Col><i className="ri-text-spacing"></i></Col>
              <Col><i className="ri-text-wrap"></i></Col>
              <Col><i className="ri-attachment-2"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-link"></i></Col>
              <Col><i className="ri-link-unlink"></i></Col>
              <Col><i className="ri-link-m"></i></Col>
              <Col><i className="ri-link-unlink-m"></i></Col>
              <Col><i className="ri-separator"></i></Col>
              <Col><i className="ri-space"></i></Col>
              <Col><i className="ri-page-separator"></i></Col>
              <Col><i className="ri-code-view"></i></Col>
              <Col><i className="ri-double-quotes-l"></i></Col>
              <Col><i className="ri-double-quotes-r"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-single-quotes-l"></i></Col>
              <Col><i className="ri-single-quotes-r"></i></Col>
              <Col><i className="ri-table-2"></i></Col>
              <Col><i className="ri-subscript"></i></Col>
              <Col><i className="ri-subscript-2"></i></Col>
              <Col><i className="ri-superscript"></i></Col>
              <Col><i className="ri-superscript-2"></i></Col>
              <Col><i className="ri-paragraph"></i></Col>
              <Col><i className="ri-text-direction-l"></i></Col>
              <Col><i className="ri-text-direction-r"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-functions"></i></Col>
              <Col><i className="ri-omega"></i></Col>
              <Col><i className="ri-hashtag"></i></Col>
              <Col><i className="ri-asterisk"></i></Col>
              <Col><i className="ri-question-mark"></i></Col>
              <Col><i className="ri-translate"></i></Col>
              <Col><i className="ri-translate-2"></i></Col>
              <Col><i className="ri-a-b"></i></Col>
              <Col><i className="ri-english-input"></i></Col>
              <Col><i className="ri-pinyin-input"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-wubi-input"></i></Col>
              <Col><i className="ri-input-cursor-move"></i></Col>
              <Col><i className="ri-number-1"></i></Col>
              <Col><i className="ri-number-2"></i></Col>
              <Col><i className="ri-number-3"></i></Col>
              <Col><i className="ri-number-4"></i></Col>
              <Col><i className="ri-number-5"></i></Col>
              <Col><i className="ri-number-6"></i></Col>
              <Col><i className="ri-number-7"></i></Col>
              <Col><i className="ri-number-8"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-number-9"></i></Col>
              <Col><i className="ri-number-0"></i></Col>
              <Col><i className="ri-sort-asc"></i></Col>
              <Col><i className="ri-sort-desc"></i></Col>
              <Col><i className="ri-bring-forward"></i></Col>
              <Col><i className="ri-send-backward"></i></Col>
              <Col><i className="ri-bring-to-front"></i></Col>
              <Col><i className="ri-send-to-back"></i></Col>
              <Col><i className="ri-h-1"></i></Col>
              <Col><i className="ri-h-2"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-h-3"></i></Col>
              <Col><i className="ri-h-4"></i></Col>
              <Col><i className="ri-h-5"></i></Col>
              <Col><i className="ri-h-6"></i></Col>
              <Col><i className="ri-insert-column-left"></i></Col>
              <Col><i className="ri-insert-column-right"></i></Col>
              <Col><i className="ri-insert-row-top"></i></Col>
              <Col><i className="ri-insert-row-bottom"></i></Col>
              <Col><i className="ri-delete-column"></i></Col>
              <Col><i className="ri-delete-row"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-merge-cells-horizontal"></i></Col>
              <Col><i className="ri-merge-cells-vertical"></i></Col>
              <Col><i className="ri-split-cells-horizontal"></i></Col>
              <Col><i className="ri-split-cells-vertical"></i></Col>
              <Col><i className="ri-flow-chart"></i></Col>
              <Col><i className="ri-mind-map"></i></Col>
              <Col><i className="ri-node-tree"></i></Col>
              <Col><i className="ri-organization-chart"></i></Col>
              <Col><i className="ri-rounded-corner"></i></Col>
              <Col></Col>
            </Row>
          </div>

          <br /><br /><br />

          <h5 id="section9" className="main-subtitle">Finance</h5>

          <div className="icon-group">
            <Row className="gx-1 gy-2">
              <Col><i className="ri-wallet-line"></i></Col>
              <Col><i className="ri-wallet-2-line"></i></Col>
              <Col><i className="ri-wallet-3-line"></i></Col>
              <Col><i className="ri-bank-card-line"></i></Col>
              <Col><i className="ri-bank-card-2-line"></i></Col>
              <Col><i className="ri-secure-payment-line"></i></Col>
              <Col><i className="ri-refund-line"></i></Col>
              <Col><i className="ri-refund-2-line"></i></Col>
              <Col><i className="ri-safe-line"></i></Col>
              <Col><i className="ri-safe-2-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-wallet-fill"></i></Col>
              <Col><i className="ri-wallet-2-fill"></i></Col>
              <Col><i className="ri-wallet-3-fill"></i></Col>
              <Col><i className="ri-bank-card-fill"></i></Col>
              <Col><i className="ri-bank-card-2-fill"></i></Col>
              <Col><i className="ri-secure-payment-fill"></i></Col>
              <Col><i className="ri-refund-fill"></i></Col>
              <Col><i className="ri-refund-2-fill"></i></Col>
              <Col><i className="ri-safe-fill"></i></Col>
              <Col><i className="ri-safe-2-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-price-tag-line"></i></Col>
              <Col><i className="ri-price-tag-2-line"></i></Col>
              <Col><i className="ri-price-tag-3-line"></i></Col>
              <Col><i className="ri-ticket-line"></i></Col>
              <Col><i className="ri-ticket-2-line"></i></Col>
              <Col><i className="ri-coupon-line"></i></Col>
              <Col><i className="ri-coupon-2-line"></i></Col>
              <Col><i className="ri-coupon-3-line"></i></Col>
              <Col><i className="ri-coupon-4-line"></i></Col>
              <Col><i className="ri-coupon-5-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-price-tag-fill"></i></Col>
              <Col><i className="ri-price-tag-2-fill"></i></Col>
              <Col><i className="ri-price-tag-3-fill"></i></Col>
              <Col><i className="ri-ticket-fill"></i></Col>
              <Col><i className="ri-ticket-2-fill"></i></Col>
              <Col><i className="ri-coupon-fill"></i></Col>
              <Col><i className="ri-coupon-2-fill"></i></Col>
              <Col><i className="ri-coupon-3-fill"></i></Col>
              <Col><i className="ri-coupon-4-fill"></i></Col>
              <Col><i className="ri-coupon-5-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-shopping-bag-line"></i></Col>
              <Col><i className="ri-shopping-bag-2-line"></i></Col>
              <Col><i className="ri-shopping-bag-3-line"></i></Col>
              <Col><i className="ri-shopping-basket-line"></i></Col>
              <Col><i className="ri-shopping-basket-2-line"></i></Col>
              <Col><i className="ri-shopping-cart-line"></i></Col>
              <Col><i className="ri-shopping-cart-2-line"></i></Col>
              <Col><i className="ri-vip-line"></i></Col>
              <Col><i className="ri-vip-crown-line"></i></Col>
              <Col><i className="ri-vip-crown-2-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-shopping-bag-fill"></i></Col>
              <Col><i className="ri-shopping-bag-2-fill"></i></Col>
              <Col><i className="ri-shopping-bag-3-fill"></i></Col>
              <Col><i className="ri-shopping-basket-fill"></i></Col>
              <Col><i className="ri-shopping-basket-2-fill"></i></Col>
              <Col><i className="ri-shopping-cart-fill"></i></Col>
              <Col><i className="ri-shopping-cart-2-fill"></i></Col>
              <Col><i className="ri-vip-fill"></i></Col>
              <Col><i className="ri-vip-crown-fill"></i></Col>
              <Col><i className="ri-vip-crown-2-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-vip-diamond-line"></i></Col>
              <Col><i className="ri-trophy-line"></i></Col>
              <Col><i className="ri-exchange-line"></i></Col>
              <Col><i className="ri-exchange-box-line"></i></Col>
              <Col><i className="ri-swap-line"></i></Col>
              <Col><i className="ri-swap-box-line"></i></Col>
              <Col><i className="ri-exchange-dollar-line"></i></Col>
              <Col><i className="ri-exchange-cny-line"></i></Col>
              <Col><i className="ri-exchange-funds-line"></i></Col>
              <Col><i className="ri-increase-decrease-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-vip-diamond-fill"></i></Col>
              <Col><i className="ri-trophy-fill"></i></Col>
              <Col><i className="ri-exchange-fill"></i></Col>
              <Col><i className="ri-exchange-box-fill"></i></Col>
              <Col><i className="ri-swap-fill"></i></Col>
              <Col><i className="ri-swap-box-fill"></i></Col>
              <Col><i className="ri-exchange-dollar-fill"></i></Col>
              <Col><i className="ri-exchange-cny-fill"></i></Col>
              <Col><i className="ri-exchange-funds-fill"></i></Col>
              <Col><i className="ri-increase-decrease-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-percent-line"></i></Col>
              <Col><i className="ri-copper-coin-line"></i></Col>
              <Col><i className="ri-copper-diamond-line"></i></Col>
              <Col><i className="ri-money-cny-box-line"></i></Col>
              <Col><i className="ri-money-cny-circle-line"></i></Col>
              <Col><i className="ri-money-dollar-box-line"></i></Col>
              <Col><i className="ri-money-dollar-circle-line"></i></Col>
              <Col><i className="ri-money-euro-box-line"></i></Col>
              <Col><i className="ri-money-euro-circle-line"></i></Col>
              <Col><i className="ri-money-pound-box-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-percent-fill"></i></Col>
              <Col><i className="ri-copper-coin-fill"></i></Col>
              <Col><i className="ri-copper-diamond-fill"></i></Col>
              <Col><i className="ri-money-cny-box-fill"></i></Col>
              <Col><i className="ri-money-cny-circle-fill"></i></Col>
              <Col><i className="ri-money-dollar-box-fill"></i></Col>
              <Col><i className="ri-money-dollar-circle-fill"></i></Col>
              <Col><i className="ri-money-euro-box-fill"></i></Col>
              <Col><i className="ri-money-euro-circle-fill"></i></Col>
              <Col><i className="ri-money-pound-box-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-money-pound-circle-line"></i></Col>
              <Col><i className="ri-bit-coin-line"></i></Col>
              <Col><i className="ri-coin-line"></i></Col>
              <Col><i className="ri-coins-line"></i></Col>
              <Col><i className="ri-currency-line"></i></Col>
              <Col><i className="ri-funds-line"></i></Col>
              <Col><i className="ri-funds-box-line"></i></Col>
              <Col><i className="ri-red-packet-line"></i></Col>
              <Col><i className="ri-water-flash-line"></i></Col>
              <Col><i className="ri-stock-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-money-pound-circle-fill"></i></Col>
              <Col><i className="ri-bit-coin-fill"></i></Col>
              <Col><i className="ri-coin-fill"></i></Col>
              <Col><i className="ri-coins-fill"></i></Col>
              <Col><i className="ri-currency-fill"></i></Col>
              <Col><i className="ri-funds-fill"></i></Col>
              <Col><i className="ri-funds-box-fill"></i></Col>
              <Col><i className="ri-red-packet-fill"></i></Col>
              <Col><i className="ri-water-flash-fill"></i></Col>
              <Col><i className="ri-stock-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-auction-line"></i></Col>
              <Col><i className="ri-gift-line"></i></Col>
              <Col><i className="ri-gift-2-line"></i></Col>
              <Col><i className="ri-hand-coin-line"></i></Col>
              <Col><i className="ri-hand-heart-line"></i></Col>
              <Col><i className="ri-24-hours-line"></i></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <div className="w-100"></div>
              <Col><i className="ri-auction-fill"></i></Col>
              <Col><i className="ri-gift-fill"></i></Col>
              <Col><i className="ri-gift-2-fill"></i></Col>
              <Col><i className="ri-hand-coin-fill"></i></Col>
              <Col><i className="ri-hand-heart-fill"></i></Col>
              <Col><i className="ri-24-hours-fill"></i></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
            </Row>
          </div>

          <br /><br /><br />

          <h5 id="section10" className="main-subtitle">Health &amp; Medical</h5>

          <div className="icon-group">
            <Row className="gx-1 gy-2">
              <Col><i className="ri-heart-line"></i></Col>
              <Col><i className="ri-heart-2-line"></i></Col>
              <Col><i className="ri-heart-3-line"></i></Col>
              <Col><i className="ri-heart-add-line"></i></Col>
              <Col><i className="ri-dislike-line"></i></Col>
              <Col><i className="ri-hearts-line"></i></Col>
              <Col><i className="ri-heart-pulse-line"></i></Col>
              <Col><i className="ri-pulse-line"></i></Col>
              <Col><i className="ri-empathize-line"></i></Col>
              <Col><i className="ri-nurse-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-heart-fill"></i></Col>
              <Col><i className="ri-heart-2-fill"></i></Col>
              <Col><i className="ri-heart-3-fill"></i></Col>
              <Col><i className="ri-heart-add-fill"></i></Col>
              <Col><i className="ri-dislike-fill"></i></Col>
              <Col><i className="ri-hearts-fill"></i></Col>
              <Col><i className="ri-heart-pulse-fill"></i></Col>
              <Col><i className="ri-pulse-fill"></i></Col>
              <Col><i className="ri-empathize-fill"></i></Col>
              <Col><i className="ri-nurse-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-dossier-line"></i></Col>
              <Col><i className="ri-health-book-line"></i></Col>
              <Col><i className="ri-first-aid-kit-line"></i></Col>
              <Col><i className="ri-capsule-line"></i></Col>
              <Col><i className="ri-medicine-bottle-line"></i></Col>
              <Col><i className="ri-flask-line"></i></Col>
              <Col><i className="ri-test-tube-line"></i></Col>
              <Col><i className="ri-microscope-line"></i></Col>
              <Col><i className="ri-hand-sanitizer-line"></i></Col>
              <Col><i className="ri-mental-health-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-dossier-fill"></i></Col>
              <Col><i className="ri-health-book-fill"></i></Col>
              <Col><i className="ri-first-aid-kit-fill"></i></Col>
              <Col><i className="ri-capsule-fill"></i></Col>
              <Col><i className="ri-medicine-bottle-fill"></i></Col>
              <Col><i className="ri-flask-fill"></i></Col>
              <Col><i className="ri-test-tube-fill"></i></Col>
              <Col><i className="ri-microscope-fill"></i></Col>
              <Col><i className="ri-hand-sanitizer-fill"></i></Col>
              <Col><i className="ri-mental-health-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-psychotherapy-line"></i></Col>
              <Col><i className="ri-stethoscope-line"></i></Col>
              <Col><i className="ri-syringe-line"></i></Col>
              <Col><i className="ri-thermometer-line"></i></Col>
              <Col><i className="ri-infrared-thermometer-line"></i></Col>
              <Col><i className="ri-surgical-mask-line"></i></Col>
              <Col><i className="ri-virus-line"></i></Col>
              <Col><i className="ri-lungs-line"></i></Col>
              <Col><i className="ri-rest-time-line"></i></Col>
              <Col><i className="ri-zzz-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-psychotherapy-fill"></i></Col>
              <Col><i className="ri-stethoscope-fill"></i></Col>
              <Col><i className="ri-syringe-fill"></i></Col>
              <Col><i className="ri-thermometer-fill"></i></Col>
              <Col><i className="ri-infrared-thermometer-fill"></i></Col>
              <Col><i className="ri-surgical-mask-fill"></i></Col>
              <Col><i className="ri-virus-fill"></i></Col>
              <Col><i className="ri-lungs-fill"></i></Col>
              <Col><i className="ri-rest-time-fill"></i></Col>
              <Col><i className="ri-zzz-fill"></i></Col>
            </Row>
          </div>

          <br /><br /><br />

          <h5 id="section11" className="main-subtitle">Logos</h5>

          <div className="icon-group">
            <Row className="gx-1 gy-2">
              <Col><i className="ri-alipay-line"></i></Col>
              <Col><i className="ri-amazon-line"></i></Col>
              <Col><i className="ri-android-line"></i></Col>
              <Col><i className="ri-angularjs-line"></i></Col>
              <Col><i className="ri-app-store-line"></i></Col>
              <Col><i className="ri-apple-line"></i></Col>
              <Col><i className="ri-baidu-line"></i></Col>
              <Col><i className="ri-behance-line"></i></Col>
              <Col><i className="ri-bilibili-line"></i></Col>
              <Col><i className="ri-centos-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-alipay-fill"></i></Col>
              <Col><i className="ri-amazon-fill"></i></Col>
              <Col><i className="ri-android-fill"></i></Col>
              <Col><i className="ri-angularjs-fill"></i></Col>
              <Col><i className="ri-app-store-fill"></i></Col>
              <Col><i className="ri-apple-fill"></i></Col>
              <Col><i className="ri-baidu-fill"></i></Col>
              <Col><i className="ri-behance-fill"></i></Col>
              <Col><i className="ri-bilibili-fill"></i></Col>
              <Col><i className="ri-centos-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-chrome-line"></i></Col>
              <Col><i className="ri-codepen-line"></i></Col>
              <Col><i className="ri-coreos-line"></i></Col>
              <Col><i className="ri-dingding-line"></i></Col>
              <Col><i className="ri-discord-line"></i></Col>
              <Col><i className="ri-disqus-line"></i></Col>
              <Col><i className="ri-douban-line"></i></Col>
              <Col><i className="ri-dribbble-line"></i></Col>
              <Col><i className="ri-drive-line"></i></Col>
              <Col><i className="ri-dropbox-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-chrome-fill"></i></Col>
              <Col><i className="ri-codepen-fill"></i></Col>
              <Col><i className="ri-coreos-fill"></i></Col>
              <Col><i className="ri-dingding-fill"></i></Col>
              <Col><i className="ri-discord-fill"></i></Col>
              <Col><i className="ri-disqus-fill"></i></Col>
              <Col><i className="ri-douban-fill"></i></Col>
              <Col><i className="ri-dribbble-fill"></i></Col>
              <Col><i className="ri-drive-fill"></i></Col>
              <Col><i className="ri-dropbox-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-edge-line"></i></Col>
              <Col><i className="ri-evernote-line"></i></Col>
              <Col><i className="ri-facebook-line"></i></Col>
              <Col><i className="ri-facebook-circle-line"></i></Col>
              <Col><i className="ri-facebook-box-line"></i></Col>
              <Col><i className="ri-finder-line"></i></Col>
              <Col><i className="ri-firefox-line"></i></Col>
              <Col><i className="ri-flutter-line"></i></Col>
              <Col><i className="ri-gatsby-line"></i></Col>
              <Col><i className="ri-github-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-edge-fill"></i></Col>
              <Col><i className="ri-evernote-fill"></i></Col>
              <Col><i className="ri-facebook-fill"></i></Col>
              <Col><i className="ri-facebook-circle-fill"></i></Col>
              <Col><i className="ri-facebook-box-fill"></i></Col>
              <Col><i className="ri-finder-fill"></i></Col>
              <Col><i className="ri-firefox-fill"></i></Col>
              <Col><i className="ri-flutter-fill"></i></Col>
              <Col><i className="ri-gatsby-fill"></i></Col>
              <Col><i className="ri-github-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-gitlab-line"></i></Col>
              <Col><i className="ri-google-line"></i></Col>
              <Col><i className="ri-google-play-line"></i></Col>
              <Col><i className="ri-honor-of-kings-line"></i></Col>
              <Col><i className="ri-ie-line"></i></Col>
              <Col><i className="ri-instagram-line"></i></Col>
              <Col><i className="ri-invision-line"></i></Col>
              <Col><i className="ri-kakao-talk-line"></i></Col>
              <Col><i className="ri-line-line"></i></Col>
              <Col><i className="ri-linkedin-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-gitlab-fill"></i></Col>
              <Col><i className="ri-google-fill"></i></Col>
              <Col><i className="ri-google-play-fill"></i></Col>
              <Col><i className="ri-honor-of-kings-fill"></i></Col>
              <Col><i className="ri-ie-fill"></i></Col>
              <Col><i className="ri-instagram-fill"></i></Col>
              <Col><i className="ri-invision-fill"></i></Col>
              <Col><i className="ri-kakao-talk-fill"></i></Col>
              <Col><i className="ri-line-fill"></i></Col>
              <Col><i className="ri-linkedin-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-linkedin-box-line"></i></Col>
              <Col><i className="ri-mastercard-line"></i></Col>
              <Col><i className="ri-mastodon-line"></i></Col>
              <Col><i className="ri-medium-line"></i></Col>
              <Col><i className="ri-messenger-line"></i></Col>
              <Col><i className="ri-microsoft-line"></i></Col>
              <Col><i className="ri-mini-program-line"></i></Col>
              <Col><i className="ri-netease-cloud-music-line"></i></Col>
              <Col><i className="ri-netflix-line"></i></Col>
              <Col><i className="ri-npmjs-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-linkedin-box-fill"></i></Col>
              <Col><i className="ri-mastercard-fill"></i></Col>
              <Col><i className="ri-mastodon-fill"></i></Col>
              <Col><i className="ri-medium-fill"></i></Col>
              <Col><i className="ri-messenger-fill"></i></Col>
              <Col><i className="ri-microsoft-fill"></i></Col>
              <Col><i className="ri-mini-program-fill"></i></Col>
              <Col><i className="ri-netease-cloud-music-fill"></i></Col>
              <Col><i className="ri-netflix-fill"></i></Col>
              <Col><i className="ri-npmjs-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-open-source-line"></i></Col>
              <Col><i className="ri-opera-line"></i></Col>
              <Col><i className="ri-patreon-line"></i></Col>
              <Col><i className="ri-paypal-line"></i></Col>
              <Col><i className="ri-pinterest-line"></i></Col>
              <Col><i className="ri-pixelfed-line"></i></Col>
              <Col><i className="ri-playstation-line"></i></Col>
              <Col><i className="ri-product-hunt-line"></i></Col>
              <Col><i className="ri-qq-line"></i></Col>
              <Col><i className="ri-reactjs-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-open-source-fill"></i></Col>
              <Col><i className="ri-opera-fill"></i></Col>
              <Col><i className="ri-patreon-fill"></i></Col>
              <Col><i className="ri-paypal-fill"></i></Col>
              <Col><i className="ri-pinterest-fill"></i></Col>
              <Col><i className="ri-pixelfed-fill"></i></Col>
              <Col><i className="ri-playstation-fill"></i></Col>
              <Col><i className="ri-product-hunt-fill"></i></Col>
              <Col><i className="ri-qq-fill"></i></Col>
              <Col><i className="ri-reactjs-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-reddit-line"></i></Col>
              <Col><i className="ri-remixicon-line"></i></Col>
              <Col><i className="ri-safari-line"></i></Col>
              <Col><i className="ri-skype-line"></i></Col>
              <Col><i className="ri-slack-line"></i></Col>
              <Col><i className="ri-snapchat-line"></i></Col>
              <Col><i className="ri-soundcloud-line"></i></Col>
              <Col><i className="ri-spectrum-line"></i></Col>
              <Col><i className="ri-spotify-line"></i></Col>
              <Col><i className="ri-stack-overflow-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-reddit-fill"></i></Col>
              <Col><i className="ri-remixicon-fill"></i></Col>
              <Col><i className="ri-safari-fill"></i></Col>
              <Col><i className="ri-skype-fill"></i></Col>
              <Col><i className="ri-slack-fill"></i></Col>
              <Col><i className="ri-snapchat-fill"></i></Col>
              <Col><i className="ri-soundcloud-fill"></i></Col>
              <Col><i className="ri-spectrum-fill"></i></Col>
              <Col><i className="ri-spotify-fill"></i></Col>
              <Col><i className="ri-stack-overflow-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-stackshare-line"></i></Col>
              <Col><i className="ri-steam-line"></i></Col>
              <Col><i className="ri-switch-line"></i></Col>
              <Col><i className="ri-taobao-line"></i></Col>
              <Col><i className="ri-telegram-line"></i></Col>
              <Col><i className="ri-trello-line"></i></Col>
              <Col><i className="ri-tumblr-line"></i></Col>
              <Col><i className="ri-twitch-line"></i></Col>
              <Col><i className="ri-twitter-line"></i></Col>
              <Col><i className="ri-ubuntu-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-stackshare-fill"></i></Col>
              <Col><i className="ri-steam-fill"></i></Col>
              <Col><i className="ri-switch-fill"></i></Col>
              <Col><i className="ri-taobao-fill"></i></Col>
              <Col><i className="ri-telegram-fill"></i></Col>
              <Col><i className="ri-trello-fill"></i></Col>
              <Col><i className="ri-tumblr-fill"></i></Col>
              <Col><i className="ri-twitch-fill"></i></Col>
              <Col><i className="ri-twitter-fill"></i></Col>
              <Col><i className="ri-ubuntu-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-unsplash-line"></i></Col>
              <Col><i className="ri-vimeo-line"></i></Col>
              <Col><i className="ri-visa-line"></i></Col>
              <Col><i className="ri-vuejs-line"></i></Col>
              <Col><i className="ri-wechat-line"></i></Col>
              <Col><i className="ri-wechat-2-line"></i></Col>
              <Col><i className="ri-wechat-pay-line"></i></Col>
              <Col><i className="ri-weibo-line"></i></Col>
              <Col><i className="ri-whatsapp-line"></i></Col>
              <Col><i className="ri-windows-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-unsplash-fill"></i></Col>
              <Col><i className="ri-vimeo-fill"></i></Col>
              <Col><i className="ri-visa-fill"></i></Col>
              <Col><i className="ri-vuejs-fill"></i></Col>
              <Col><i className="ri-wechat-fill"></i></Col>
              <Col><i className="ri-wechat-2-fill"></i></Col>
              <Col><i className="ri-wechat-pay-fill"></i></Col>
              <Col><i className="ri-weibo-fill"></i></Col>
              <Col><i className="ri-whatsapp-fill"></i></Col>
              <Col><i className="ri-windows-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-xbox-line"></i></Col>
              <Col><i className="ri-xing-line"></i></Col>
              <Col><i className="ri-youtube-line"></i></Col>
              <Col><i className="ri-zcool-line"></i></Col>
              <Col><i className="ri-zhihu-line"></i></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <div className="w-100"></div>
              <Col><i className="ri-xbox-fill"></i></Col>
              <Col><i className="ri-xing-fill"></i></Col>
              <Col><i className="ri-youtube-fill"></i></Col>
              <Col><i className="ri-zcool-fill"></i></Col>
              <Col><i className="ri-zhihu-fill"></i></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
            </Row>
          </div>

          <br /><br /><br />

          <h5 id="section12" className="main-subtitle">Map</h5>

          <div className="icon-group">
            <Row className="gx-1 gy-2">
              <Col><i className="ri-map-line"></i></Col>
              <Col><i className="ri-map-pin-2-line"></i></Col>
              <Col><i className="ri-map-pin-3-line"></i></Col>
              <Col><i className="ri-map-pin-4-line"></i></Col>
              <Col><i className="ri-map-pin-5-line"></i></Col>
              <Col><i className="ri-map-pin-add-line"></i></Col>
              <Col><i className="ri-map-pin-range-line"></i></Col>
              <Col><i className="ri-map-pin-time-line"></i></Col>
              <Col><i className="ri-map-pin-user-line"></i></Col>
              <Col><i className="ri-pin-distance-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-map-fill"></i></Col>
              <Col><i className="ri-map-pin-2-fill"></i></Col>
              <Col><i className="ri-map-pin-3-fill"></i></Col>
              <Col><i className="ri-map-pin-4-fill"></i></Col>
              <Col><i className="ri-map-pin-5-fill"></i></Col>
              <Col><i className="ri-map-pin-add-fill"></i></Col>
              <Col><i className="ri-map-pin-range-fill"></i></Col>
              <Col><i className="ri-map-pin-time-fill"></i></Col>
              <Col><i className="ri-map-pin-user-fill"></i></Col>
              <Col><i className="ri-pin-distance-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-pushpin-line"></i></Col>
              <Col><i className="ri-pushpin-2-line"></i></Col>
              <Col><i className="ri-compass-line"></i></Col>
              <Col><i className="ri-compass-2-line"></i></Col>
              <Col><i className="ri-compass-3-line"></i></Col>
              <Col><i className="ri-compass-4-line"></i></Col>
              <Col><i className="ri-compass-discover-line"></i></Col>
              <Col><i className="ri-anchor-line"></i></Col>
              <Col><i className="ri-china-railway-line"></i></Col>
              <Col><i className="ri-space-ship-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-pushpin-fill"></i></Col>
              <Col><i className="ri-pushpin-2-fill"></i></Col>
              <Col><i className="ri-compass-fill"></i></Col>
              <Col><i className="ri-compass-2-fill"></i></Col>
              <Col><i className="ri-compass-3-fill"></i></Col>
              <Col><i className="ri-compass-4-fill"></i></Col>
              <Col><i className="ri-compass-discover-fill"></i></Col>
              <Col><i className="ri-anchor-fill"></i></Col>
              <Col><i className="ri-china-railway-fill"></i></Col>
              <Col><i className="ri-space-ship-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-rocket-line"></i></Col>
              <Col><i className="ri-rocket-2-line"></i></Col>
              <Col><i className="ri-map-line"></i></Col>
              <Col><i className="ri-map-2-line"></i></Col>
              <Col><i className="ri-treasure-map-line"></i></Col>
              <Col><i className="ri-road-map-line"></i></Col>
              <Col><i className="ri-earth-line"></i></Col>
              <Col><i className="ri-globe-line"></i></Col>
              <Col><i className="ri-parking-line"></i></Col>
              <Col><i className="ri-parking-box-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-rocket-fill"></i></Col>
              <Col><i className="ri-rocket-2-fill"></i></Col>
              <Col><i className="ri-map-fill"></i></Col>
              <Col><i className="ri-map-2-fill"></i></Col>
              <Col><i className="ri-treasure-map-fill"></i></Col>
              <Col><i className="ri-road-map-fill"></i></Col>
              <Col><i className="ri-earth-fill"></i></Col>
              <Col><i className="ri-globe-fill"></i></Col>
              <Col><i className="ri-parking-fill"></i></Col>
              <Col><i className="ri-parking-box-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-route-line"></i></Col>
              <Col><i className="ri-guide-line"></i></Col>
              <Col><i className="ri-gas-station-line"></i></Col>
              <Col><i className="ri-charging-pile-line"></i></Col>
              <Col><i className="ri-charging-pile-2-line"></i></Col>
              <Col><i className="ri-car-line"></i></Col>
              <Col><i className="ri-car-washing-line"></i></Col>
              <Col><i className="ri-roadster-line"></i></Col>
              <Col><i className="ri-taxi-line"></i></Col>
              <Col><i className="ri-taxi-wifi-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-route-fill"></i></Col>
              <Col><i className="ri-guide-fill"></i></Col>
              <Col><i className="ri-gas-station-fill"></i></Col>
              <Col><i className="ri-charging-pile-fill"></i></Col>
              <Col><i className="ri-charging-pile-2-fill"></i></Col>
              <Col><i className="ri-car-fill"></i></Col>
              <Col><i className="ri-car-washing-fill"></i></Col>
              <Col><i className="ri-roadster-fill"></i></Col>
              <Col><i className="ri-taxi-fill"></i></Col>
              <Col><i className="ri-taxi-wifi-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-police-car-line"></i></Col>
              <Col><i className="ri-bus-line"></i></Col>
              <Col><i className="ri-bus-2-line"></i></Col>
              <Col><i className="ri-bus-wifi-line"></i></Col>
              <Col><i className="ri-truck-line"></i></Col>
              <Col><i className="ri-train-line"></i></Col>
              <Col><i className="ri-train-wifi-line"></i></Col>
              <Col><i className="ri-subway-line"></i></Col>
              <Col><i className="ri-subway-wifi-line"></i></Col>
              <Col><i className="ri-flight-takeoff-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-police-car-fill"></i></Col>
              <Col><i className="ri-bus-fill"></i></Col>
              <Col><i className="ri-bus-2-fill"></i></Col>
              <Col><i className="ri-bus-wifi-fill"></i></Col>
              <Col><i className="ri-truck-fill"></i></Col>
              <Col><i className="ri-train-fill"></i></Col>
              <Col><i className="ri-train-wifi-fill"></i></Col>
              <Col><i className="ri-subway-fill"></i></Col>
              <Col><i className="ri-subway-wifi-fill"></i></Col>
              <Col><i className="ri-flight-takeoff-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-flight-land-line"></i></Col>
              <Col><i className="ri-plane-line"></i></Col>
              <Col><i className="ri-sailboat-line"></i></Col>
              <Col><i className="ri-ship-line"></i></Col>
              <Col><i className="ri-ship-2-line"></i></Col>
              <Col><i className="ri-bike-line"></i></Col>
              <Col><i className="ri-e-bike-line"></i></Col>
              <Col><i className="ri-e-bike-2-line"></i></Col>
              <Col><i className="ri-takeaway-line"></i></Col>
              <Col><i className="ri-motorbike-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-flight-land-fill"></i></Col>
              <Col><i className="ri-plane-fill"></i></Col>
              <Col><i className="ri-sailboat-fill"></i></Col>
              <Col><i className="ri-ship-fill"></i></Col>
              <Col><i className="ri-ship-2-fill"></i></Col>
              <Col><i className="ri-bike-fill"></i></Col>
              <Col><i className="ri-e-bike-fill"></i></Col>
              <Col><i className="ri-e-bike-2-fill"></i></Col>
              <Col><i className="ri-takeaway-fill"></i></Col>
              <Col><i className="ri-motorbike-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-caravan-line"></i></Col>
              <Col><i className="ri-walk-line"></i></Col>
              <Col><i className="ri-run-line"></i></Col>
              <Col><i className="ri-riding-line"></i></Col>
              <Col><i className="ri-barricade-line"></i></Col>
              <Col><i className="ri-footprint-line"></i></Col>
              <Col><i className="ri-traffic-light-line"></i></Col>
              <Col><i className="ri-signal-tower-line"></i></Col>
              <Col><i className="ri-restaurant-line"></i></Col>
              <Col><i className="ri-restaurant-2-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-caravan-fill"></i></Col>
              <Col><i className="ri-walk-fill"></i></Col>
              <Col><i className="ri-run-fill"></i></Col>
              <Col><i className="ri-riding-fill"></i></Col>
              <Col><i className="ri-barricade-fill"></i></Col>
              <Col><i className="ri-footprint-fill"></i></Col>
              <Col><i className="ri-traffic-light-fill"></i></Col>
              <Col><i className="ri-signal-tower-fill"></i></Col>
              <Col><i className="ri-restaurant-fill"></i></Col>
              <Col><i className="ri-restaurant-2-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-cup-line"></i></Col>
              <Col><i className="ri-goblet-line"></i></Col>
              <Col><i className="ri-hotel-bed-line"></i></Col>
              <Col><i className="ri-navigation-line"></i></Col>
              <Col><i className="ri-oil-line"></i></Col>
              <Col><i className="ri-direction-line"></i></Col>
              <Col><i className="ri-steering-line"></i></Col>
              <Col><i className="ri-steering-2-line"></i></Col>
              <Col><i className="ri-lifebuoy-line"></i></Col>
              <Col><i className="ri-passport-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-cup-fill"></i></Col>
              <Col><i className="ri-goblet-fill"></i></Col>
              <Col><i className="ri-hotel-bed-fill"></i></Col>
              <Col><i className="ri-navigation-fill"></i></Col>
              <Col><i className="ri-oil-fill"></i></Col>
              <Col><i className="ri-direction-fill"></i></Col>
              <Col><i className="ri-steering-fill"></i></Col>
              <Col><i className="ri-steering-2-fill"></i></Col>
              <Col><i className="ri-lifebuoy-fill"></i></Col>
              <Col><i className="ri-passport-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-suitcase-line"></i></Col>
              <Col><i className="ri-suitcase-2-line"></i></Col>
              <Col><i className="ri-suitcase-3-line"></i></Col>
              <Col><i className="ri-luggage-deposit-line"></i></Col>
              <Col><i className="ri-luggage-cart-line"></i></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <div className="w-100"></div>
              <Col><i className="ri-suitcase-fill"></i></Col>
              <Col><i className="ri-suitcase-2-fill"></i></Col>
              <Col><i className="ri-suitcase-3-fill"></i></Col>
              <Col><i className="ri-luggage-deposit-fill"></i></Col>
              <Col><i className="ri-luggage-cart-fill"></i></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
            </Row>
          </div>

          <br /><br /><br />

          <h5 id="section13" className="main-subtitle">Media</h5>

          <div className="icon-group">
            <Row className="gx-1 gy-2">
              <Col><i className="ri-image-line"></i></Col>
              <Col><i className="ri-image-2-line"></i></Col>
              <Col><i className="ri-image-add-line"></i></Col>
              <Col><i className="ri-image-edit-line"></i></Col>
              <Col><i className="ri-landscape-line"></i></Col>
              <Col><i className="ri-gallery-line"></i></Col>
              <Col><i className="ri-gallery-upload-line"></i></Col>
              <Col><i className="ri-video-line"></i></Col>
              <Col><i className="ri-movie-line"></i></Col>
              <Col><i className="ri-movie-2-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-image-fill"></i></Col>
              <Col><i className="ri-image-2-fill"></i></Col>
              <Col><i className="ri-image-add-fill"></i></Col>
              <Col><i className="ri-image-edit-fill"></i></Col>
              <Col><i className="ri-landscape-fill"></i></Col>
              <Col><i className="ri-gallery-fill"></i></Col>
              <Col><i className="ri-gallery-upload-fill"></i></Col>
              <Col><i className="ri-video-fill"></i></Col>
              <Col><i className="ri-movie-fill"></i></Col>
              <Col><i className="ri-movie-2-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-film-line"></i></Col>
              <Col><i className="ri-clapperboard-line"></i></Col>
              <Col><i className="ri-vidicon-line"></i></Col>
              <Col><i className="ri-vidicon-2-line"></i></Col>
              <Col><i className="ri-live-line"></i></Col>
              <Col><i className="ri-video-add-line"></i></Col>
              <Col><i className="ri-video-upload-line"></i></Col>
              <Col><i className="ri-video-download-line"></i></Col>
              <Col><i className="ri-dv-line"></i></Col>
              <Col><i className="ri-camera-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-film-fill"></i></Col>
              <Col><i className="ri-clapperboard-fill"></i></Col>
              <Col><i className="ri-vidicon-fill"></i></Col>
              <Col><i className="ri-vidicon-2-fill"></i></Col>
              <Col><i className="ri-live-fill"></i></Col>
              <Col><i className="ri-video-add-fill"></i></Col>
              <Col><i className="ri-video-upload-fill"></i></Col>
              <Col><i className="ri-video-download-fill"></i></Col>
              <Col><i className="ri-dv-fill"></i></Col>
              <Col><i className="ri-camera-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-camera-off-line"></i></Col>
              <Col><i className="ri-camera-2-line"></i></Col>
              <Col><i className="ri-camera-3-line"></i></Col>
              <Col><i className="ri-camera-lens-line"></i></Col>
              <Col><i className="ri-camera-switch-line"></i></Col>
              <Col><i className="ri-polaroid-line"></i></Col>
              <Col><i className="ri-polaroid-2-line"></i></Col>
              <Col><i className="ri-phone-camera-line"></i></Col>
              <Col><i className="ri-webcam-line"></i></Col>
              <Col><i className="ri-mv-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-camera-off-fill"></i></Col>
              <Col><i className="ri-camera-2-fill"></i></Col>
              <Col><i className="ri-camera-3-fill"></i></Col>
              <Col><i className="ri-camera-lens-fill"></i></Col>
              <Col><i className="ri-camera-switch-fill"></i></Col>
              <Col><i className="ri-polaroid-fill"></i></Col>
              <Col><i className="ri-polaroid-2-fill"></i></Col>
              <Col><i className="ri-phone-camera-fill"></i></Col>
              <Col><i className="ri-webcam-fill"></i></Col>
              <Col><i className="ri-mv-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-music-line"></i></Col>
              <Col><i className="ri-music-2-line"></i></Col>
              <Col><i className="ri-disc-line"></i></Col>
              <Col><i className="ri-album-line"></i></Col>
              <Col><i className="ri-dvd-line"></i></Col>
              <Col><i className="ri-headphone-line"></i></Col>
              <Col><i className="ri-radio-line"></i></Col>
              <Col><i className="ri-radio-2-line"></i></Col>
              <Col><i className="ri-tape-line"></i></Col>
              <Col><i className="ri-mic-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-music-fill"></i></Col>
              <Col><i className="ri-music-2-fill"></i></Col>
              <Col><i className="ri-disc-fill"></i></Col>
              <Col><i className="ri-album-fill"></i></Col>
              <Col><i className="ri-dvd-fill"></i></Col>
              <Col><i className="ri-headphone-fill"></i></Col>
              <Col><i className="ri-radio-fill"></i></Col>
              <Col><i className="ri-radio-2-fill"></i></Col>
              <Col><i className="ri-tape-fill"></i></Col>
              <Col><i className="ri-mic-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-mic-2-line"></i></Col>
              <Col><i className="ri-mic-off-line"></i></Col>
              <Col><i className="ri-volume-down-line"></i></Col>
              <Col><i className="ri-volume-mute-line"></i></Col>
              <Col><i className="ri-volume-up-line"></i></Col>
              <Col><i className="ri-volume-vibrate-line"></i></Col>
              <Col><i className="ri-volume-off-vibrate-line"></i></Col>
              <Col><i className="ri-speaker-line"></i></Col>
              <Col><i className="ri-speaker-2-line"></i></Col>
              <Col><i className="ri-speaker-3-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-mic-2-fill"></i></Col>
              <Col><i className="ri-mic-off-fill"></i></Col>
              <Col><i className="ri-volume-down-fill"></i></Col>
              <Col><i className="ri-volume-mute-fill"></i></Col>
              <Col><i className="ri-volume-up-fill"></i></Col>
              <Col><i className="ri-volume-vibrate-fill"></i></Col>
              <Col><i className="ri-volume-off-vibrate-fill"></i></Col>
              <Col><i className="ri-speaker-fill"></i></Col>
              <Col><i className="ri-speaker-2-fill"></i></Col>
              <Col><i className="ri-speaker-3-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-surround-sound-line"></i></Col>
              <Col><i className="ri-broadcast-line"></i></Col>
              <Col><i className="ri-notification-line"></i></Col>
              <Col><i className="ri-notification-2-line"></i></Col>
              <Col><i className="ri-notification-3-line"></i></Col>
              <Col><i className="ri-notification-4-line"></i></Col>
              <Col><i className="ri-notification-off-line"></i></Col>
              <Col><i className="ri-play-circle-line"></i></Col>
              <Col><i className="ri-pause-circle-line"></i></Col>
              <Col><i className="ri-record-circle-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-surround-sound-fill"></i></Col>
              <Col><i className="ri-broadcast-fill"></i></Col>
              <Col><i className="ri-notification-fill"></i></Col>
              <Col><i className="ri-notification-2-fill"></i></Col>
              <Col><i className="ri-notification-3-fill"></i></Col>
              <Col><i className="ri-notification-4-fill"></i></Col>
              <Col><i className="ri-notification-off-fill"></i></Col>
              <Col><i className="ri-play-circle-fill"></i></Col>
              <Col><i className="ri-pause-circle-fill"></i></Col>
              <Col><i className="ri-record-circle-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-stop-circle-line"></i></Col>
              <Col><i className="ri-eject-line"></i></Col>
              <Col><i className="ri-play-line"></i></Col>
              <Col><i className="ri-pause-line"></i></Col>
              <Col><i className="ri-stop-line"></i></Col>
              <Col><i className="ri-rewind-line"></i></Col>
              <Col><i className="ri-speed-line"></i></Col>
              <Col><i className="ri-skip-back-line"></i></Col>
              <Col><i className="ri-skip-forward-line"></i></Col>
              <Col><i className="ri-play-mini-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-stop-circle-fill"></i></Col>
              <Col><i className="ri-eject-fill"></i></Col>
              <Col><i className="ri-play-fill"></i></Col>
              <Col><i className="ri-pause-fill"></i></Col>
              <Col><i className="ri-stop-fill"></i></Col>
              <Col><i className="ri-rewind-fill"></i></Col>
              <Col><i className="ri-speed-fill"></i></Col>
              <Col><i className="ri-skip-back-fill"></i></Col>
              <Col><i className="ri-skip-forward-fill"></i></Col>
              <Col><i className="ri-play-mini-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-pause-mini-line"></i></Col>
              <Col><i className="ri-stop-mini-line"></i></Col>
              <Col><i className="ri-rewind-mini-line"></i></Col>
              <Col><i className="ri-speed-mini-line"></i></Col>
              <Col><i className="ri-skip-back-mini-line"></i></Col>
              <Col><i className="ri-skip-forward-mini-line"></i></Col>
              <Col><i className="ri-repeat-line"></i></Col>
              <Col><i className="ri-repeat-2-line"></i></Col>
              <Col><i className="ri-repeat-one-line"></i></Col>
              <Col><i className="ri-order-play-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-pause-mini-fill"></i></Col>
              <Col><i className="ri-stop-mini-fill"></i></Col>
              <Col><i className="ri-rewind-mini-fill"></i></Col>
              <Col><i className="ri-speed-mini-fill"></i></Col>
              <Col><i className="ri-skip-back-mini-fill"></i></Col>
              <Col><i className="ri-skip-forward-mini-fill"></i></Col>
              <Col><i className="ri-repeat-fill"></i></Col>
              <Col><i className="ri-repeat-2-fill"></i></Col>
              <Col><i className="ri-repeat-one-fill"></i></Col>
              <Col><i className="ri-order-play-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-shuffle-line"></i></Col>
              <Col><i className="ri-play-list-line"></i></Col>
              <Col><i className="ri-play-list-2-line"></i></Col>
              <Col><i className="ri-play-list-add-line"></i></Col>
              <Col><i className="ri-fullscreen-line"></i></Col>
              <Col><i className="ri-fullscreen-exit-line"></i></Col>
              <Col><i className="ri-equalizer-line"></i></Col>
              <Col><i className="ri-sound-module-line"></i></Col>
              <Col><i className="ri-rhythm-line"></i></Col>
              <Col><i className="ri-voiceprint-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-hq-line"></i></Col>
              <Col><i className="ri-hd-line"></i></Col>
              <Col><i className="ri-4k-line"></i></Col>
              <Col><i className="ri-closed-captioning-line"></i></Col>
              <Col><i className="ri-aspect-ratio-line"></i></Col>
              <Col><i className="ri-picture-in-picture-line"></i></Col>
              <Col><i className="ri-picture-in-picture-2-line"></i></Col>
              <Col><i className="ri-picture-in-picture-exit-line"></i></Col>
              <Col></Col>
              <Col></Col>
              <div className="w-100"></div>
              <Col><i className="ri-hq-fill"></i></Col>
              <Col><i className="ri-hd-fill"></i></Col>
              <Col><i className="ri-4k-fill"></i></Col>
              <Col><i className="ri-closed-captioning-fill"></i></Col>
              <Col><i className="ri-aspect-ratio-fill"></i></Col>
              <Col><i className="ri-picture-in-picture-fill"></i></Col>
              <Col><i className="ri-picture-in-picture-2-fill"></i></Col>
              <Col><i className="ri-picture-in-picture-exit-fill"></i></Col>
              <Col></Col>
              <Col></Col>
            </Row>
          </div>

          <br /><br /><br />

          <h5 id="section14" className="main-subtitle">System</h5>

          <div className="icon-group">
            <Row className="gx-1 gy-2">
              <Col><i className="ri-apps-line"></i></Col>
              <Col><i className="ri-apps-2-line"></i></Col>
              <Col><i className="ri-function-line"></i></Col>
              <Col><i className="ri-dashboard-line"></i></Col>
              <Col><i className="ri-menu-line"></i></Col>
              <Col><i className="ri-menu-2-line"></i></Col>
              <Col><i className="ri-menu-3-line"></i></Col>
              <Col><i className="ri-menu-4-line"></i></Col>
              <Col><i className="ri-menu-5-line"></i></Col>
              <Col><i className="ri-menu-add-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-apps-fill"></i></Col>
              <Col><i className="ri-apps-2-fill"></i></Col>
              <Col><i className="ri-function-fill"></i></Col>
              <Col><i className="ri-dashboard-fill"></i></Col>
              <Col><i className="ri-menu-fill"></i></Col>
              <Col><i className="ri-menu-2-fill"></i></Col>
              <Col><i className="ri-menu-3-fill"></i></Col>
              <Col><i className="ri-menu-4-fill"></i></Col>
              <Col><i className="ri-menu-5-fill"></i></Col>
              <Col><i className="ri-menu-add-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-menu-fold-line"></i></Col>
              <Col><i className="ri-menu-unfold-line"></i></Col>
              <Col><i className="ri-more-line"></i></Col>
              <Col><i className="ri-more-2-line"></i></Col>
              <Col><i className="ri-star-line"></i></Col>
              <Col><i className="ri-star-s-line"></i></Col>
              <Col><i className="ri-star-half-line"></i></Col>
              <Col><i className="ri-star-half-s-line"></i></Col>
              <Col><i className="ri-settings-line"></i></Col>
              <Col><i className="ri-settings-2-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-menu-fold-fill"></i></Col>
              <Col><i className="ri-menu-unfold-fill"></i></Col>
              <Col><i className="ri-more-fill"></i></Col>
              <Col><i className="ri-more-2-fill"></i></Col>
              <Col><i className="ri-star-fill"></i></Col>
              <Col><i className="ri-star-s-fill"></i></Col>
              <Col><i className="ri-star-half-fill"></i></Col>
              <Col><i className="ri-star-half-s-fill"></i></Col>
              <Col><i className="ri-settings-fill"></i></Col>
              <Col><i className="ri-settings-2-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-settings-3-line"></i></Col>
              <Col><i className="ri-settings-4-line"></i></Col>
              <Col><i className="ri-settings-5-line"></i></Col>
              <Col><i className="ri-settings-6-line"></i></Col>
              <Col><i className="ri-list-settings-line"></i></Col>
              <Col><i className="ri-forbid-line"></i></Col>
              <Col><i className="ri-forbid-2-line"></i></Col>
              <Col><i className="ri-information-line"></i></Col>
              <Col><i className="ri-error-warning-line"></i></Col>
              <Col><i className="ri-question-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-settings-3-fill"></i></Col>
              <Col><i className="ri-settings-4-fill"></i></Col>
              <Col><i className="ri-settings-5-fill"></i></Col>
              <Col><i className="ri-settings-6-fill"></i></Col>
              <Col><i className="ri-list-settings-fill"></i></Col>
              <Col><i className="ri-forbid-fill"></i></Col>
              <Col><i className="ri-forbid-2-fill"></i></Col>
              <Col><i className="ri-information-fill"></i></Col>
              <Col><i className="ri-error-warning-fill"></i></Col>
              <Col><i className="ri-question-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-alert-line"></i></Col>
              <Col><i className="ri-spam-line"></i></Col>
              <Col><i className="ri-spam-2-line"></i></Col>
              <Col><i className="ri-spam-3-line"></i></Col>
              <Col><i className="ri-checkbox-blank-line"></i></Col>
              <Col><i className="ri-fille"></i></Col>
              <Col><i className="ri-checkbox-indeterminate-line"></i></Col>
              <Col><i className="ri-add-box-line"></i></Col>
              <Col><i className="ri-checkbox-blank-circle-line"></i></Col>
              <Col><i className="ri-checkbox-circle-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-alert-fill"></i></Col>
              <Col><i className="ri-spam-fill"></i></Col>
              <Col><i className="ri-spam-2-fill"></i></Col>
              <Col><i className="ri-spam-3-fill"></i></Col>
              <Col><i className="ri-checkbox-blank-fill"></i></Col>
              <Col><i className="ri-checkbox-fill"></i></Col>
              <Col><i className="ri-checkbox-indeterminate-fill"></i></Col>
              <Col><i className="ri-add-box-fill"></i></Col>
              <Col><i className="ri-checkbox-blank-circle-fill"></i></Col>
              <Col><i className="ri-checkbox-circle-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-indeterminate-circle-line"></i></Col>
              <Col><i className="ri-add-circle-line"></i></Col>
              <Col><i className="ri-close-circle-line"></i></Col>
              <Col><i className="ri-radio-button-line"></i></Col>
              <Col><i className="ri-checkbox-multiple-blank-line"></i></Col>
              <Col><i className="ri-checkbox-multiple-line"></i></Col>
              <Col><i className="ri-check-line"></i></Col>
              <Col><i className="ri-check-double-line"></i></Col>
              <Col><i className="ri-close-line"></i></Col>
              <Col><i className="ri-add-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-indeterminate-circle-fill"></i></Col>
              <Col><i className="ri-add-circle-fill"></i></Col>
              <Col><i className="ri-close-circle-fill"></i></Col>
              <Col><i className="ri-radio-button-fill"></i></Col>
              <Col><i className="ri-checkbox-multiple-blank-fill"></i></Col>
              <Col><i className="ri-checkbox-multiple-fill"></i></Col>
              <Col><i className="ri-check-fill"></i></Col>
              <Col><i className="ri-check-double-fill"></i></Col>
              <Col><i className="ri-close-fill"></i></Col>
              <Col><i className="ri-add-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-subtract-line"></i></Col>
              <Col><i className="ri-divide-line"></i></Col>
              <Col><i className="ri-arrow-left-up-line"></i></Col>
              <Col><i className="ri-arrow-up-line"></i></Col>
              <Col><i className="ri-arrow-right-up-line"></i></Col>
              <Col><i className="ri-arrow-right-line"></i></Col>
              <Col><i className="ri-arrow-right-down-line"></i></Col>
              <Col><i className="ri-arrow-down-line"></i></Col>
              <Col><i className="ri-arrow-left-down-line"></i></Col>
              <Col><i className="ri-arrow-left-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-subtract-fill"></i></Col>
              <Col><i className="ri-divide-fill"></i></Col>
              <Col><i className="ri-arrow-left-up-fill"></i></Col>
              <Col><i className="ri-arrow-up-fill"></i></Col>
              <Col><i className="ri-arrow-right-up-fill"></i></Col>
              <Col><i className="ri-arrow-right-fill"></i></Col>
              <Col><i className="ri-arrow-right-down-fill"></i></Col>
              <Col><i className="ri-arrow-down-fill"></i></Col>
              <Col><i className="ri-arrow-left-down-fill"></i></Col>
              <Col><i className="ri-arrow-left-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-arrow-up-circle-line"></i></Col>
              <Col><i className="ri-arrow-right-circle-line"></i></Col>
              <Col><i className="ri-arrow-down-circle-line"></i></Col>
              <Col><i className="ri-arrow-left-circle-line"></i></Col>
              <Col><i className="ri-arrow-up-s-line"></i></Col>
              <Col><i className="ri-arrow-down-s-line"></i></Col>
              <Col><i className="ri-arrow-right-s-line"></i></Col>
              <Col><i className="ri-arrow-left-s-line"></i></Col>
              <Col><i className="ri-arrow-drop-up-line"></i></Col>
              <Col><i className="ri-arrow-drop-right-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-arrow-up-circle-fill"></i></Col>
              <Col><i className="ri-arrow-right-circle-fill"></i></Col>
              <Col><i className="ri-arrow-down-circle-fill"></i></Col>
              <Col><i className="ri-arrow-left-circle-fill"></i></Col>
              <Col><i className="ri-arrow-up-s-fill"></i></Col>
              <Col><i className="ri-arrow-down-s-fill"></i></Col>
              <Col><i className="ri-arrow-right-s-fill"></i></Col>
              <Col><i className="ri-arrow-left-s-fill"></i></Col>
              <Col><i className="ri-arrow-drop-up-fill"></i></Col>
              <Col><i className="ri-arrow-drop-right-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-arrow-drop-down-line"></i></Col>
              <Col><i className="ri-arrow-drop-left-line"></i></Col>
              <Col><i className="ri-arrow-left-right-line"></i></Col>
              <Col><i className="ri-arrow-up-down-line"></i></Col>
              <Col><i className="ri-arrow-go-back-line"></i></Col>
              <Col><i className="ri-arrow-go-forward-line"></i></Col>
              <Col><i className="ri-download-line"></i></Col>
              <Col><i className="ri-upload-line"></i></Col>
              <Col><i className="ri-download-2-line"></i></Col>
              <Col><i className="ri-upload-2-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-arrow-drop-down-fill"></i></Col>
              <Col><i className="ri-arrow-drop-left-fill"></i></Col>
              <Col><i className="ri-arrow-left-right-fill"></i></Col>
              <Col><i className="ri-arrow-up-down-fill"></i></Col>
              <Col><i className="ri-arrow-go-back-fill"></i></Col>
              <Col><i className="ri-arrow-go-forward-fill"></i></Col>
              <Col><i className="ri-download-fill"></i></Col>
              <Col><i className="ri-upload-fill"></i></Col>
              <Col><i className="ri-download-2-fill"></i></Col>
              <Col><i className="ri-upload-2-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-download-cloud-line"></i></Col>
              <Col><i className="ri-download-cloud-2-line"></i></Col>
              <Col><i className="ri-upload-cloud-line"></i></Col>
              <Col><i className="ri-upload-cloud-2-line"></i></Col>
              <Col><i className="ri-login-box-line"></i></Col>
              <Col><i className="ri-logout-box-line"></i></Col>
              <Col><i className="ri-logout-box-r-line"></i></Col>
              <Col><i className="ri-login-circle-line"></i></Col>
              <Col><i className="ri-logout-circle-line"></i></Col>
              <Col><i className="ri-logout-circle-r-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-download-cloud-fill"></i></Col>
              <Col><i className="ri-download-cloud-2-fill"></i></Col>
              <Col><i className="ri-upload-cloud-fill"></i></Col>
              <Col><i className="ri-upload-cloud-2-fill"></i></Col>
              <Col><i className="ri-login-box-fill"></i></Col>
              <Col><i className="ri-logout-box-fill"></i></Col>
              <Col><i className="ri-logout-box-r-fill"></i></Col>
              <Col><i className="ri-login-circle-fill"></i></Col>
              <Col><i className="ri-logout-circle-fill"></i></Col>
              <Col><i className="ri-logout-circle-r-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-refresh-line"></i></Col>
              <Col><i className="ri-shield-line"></i></Col>
              <Col><i className="ri-shield-cross-line"></i></Col>
              <Col><i className="ri-shield-flash-line"></i></Col>
              <Col><i className="ri-shield-star-line"></i></Col>
              <Col><i className="ri-shield-user-line"></i></Col>
              <Col><i className="ri-shield-keyhole-line"></i></Col>
              <Col><i className="ri-shield-check-line"></i></Col>
              <Col><i className="ri-delete-back-line"></i></Col>
              <Col><i className="ri-delete-back-2-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-refresh-fill"></i></Col>
              <Col><i className="ri-shield-fill"></i></Col>
              <Col><i className="ri-shield-cross-fill"></i></Col>
              <Col><i className="ri-shield-flash-fill"></i></Col>
              <Col><i className="ri-shield-star-fill"></i></Col>
              <Col><i className="ri-shield-user-fill"></i></Col>
              <Col><i className="ri-shield-keyhole-fill"></i></Col>
              <Col><i className="ri-shield-check-fill"></i></Col>
              <Col><i className="ri-delete-back-fill"></i></Col>
              <Col><i className="ri-delete-back-2-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-delete-bin-line"></i></Col>
              <Col><i className="ri-delete-bin-2-line"></i></Col>
              <Col><i className="ri-delete-bin-3-line"></i></Col>
              <Col><i className="ri-delete-bin-4-line"></i></Col>
              <Col><i className="ri-delete-bin-5-line"></i></Col>
              <Col><i className="ri-delete-bin-6-line"></i></Col>
              <Col><i className="ri-delete-bin-7-line"></i></Col>
              <Col><i className="ri-lock-line"></i></Col>
              <Col><i className="ri-lock-2-line"></i></Col>
              <Col><i className="ri-lock-password-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-delete-bin-fill"></i></Col>
              <Col><i className="ri-delete-bin-2-fill"></i></Col>
              <Col><i className="ri-delete-bin-3-fill"></i></Col>
              <Col><i className="ri-delete-bin-4-fill"></i></Col>
              <Col><i className="ri-delete-bin-5-fill"></i></Col>
              <Col><i className="ri-delete-bin-6-fill"></i></Col>
              <Col><i className="ri-delete-bin-7-fill"></i></Col>
              <Col><i className="ri-lock-fill"></i></Col>
              <Col><i className="ri-lock-2-fill"></i></Col>
              <Col><i className="ri-lock-password-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-lock-unlock-line"></i></Col>
              <Col><i className="ri-eye-line"></i></Col>
              <Col><i className="ri-eye-off-line"></i></Col>
              <Col><i className="ri-eye-2-line"></i></Col>
              <Col><i className="ri-eye-close-line"></i></Col>
              <Col><i className="ri-search-line"></i></Col>
              <Col><i className="ri-search-2-line"></i></Col>
              <Col><i className="ri-search-eye-line"></i></Col>
              <Col><i className="ri-zoom-in-line"></i></Col>
              <Col><i className="ri-zoom-out-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-lock-unlock-fill"></i></Col>
              <Col><i className="ri-eye-fill"></i></Col>
              <Col><i className="ri-eye-off-fill"></i></Col>
              <Col><i className="ri-eye-2-fill"></i></Col>
              <Col><i className="ri-eye-close-fill"></i></Col>
              <Col><i className="ri-search-fill"></i></Col>
              <Col><i className="ri-search-2-fill"></i></Col>
              <Col><i className="ri-search-eye-fill"></i></Col>
              <Col><i className="ri-zoom-in-fill"></i></Col>
              <Col><i className="ri-zoom-out-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-find-replace-line"></i></Col>
              <Col><i className="ri-share-line"></i></Col>
              <Col><i className="ri-share-box-line"></i></Col>
              <Col><i className="ri-share-circle-line"></i></Col>
              <Col><i className="ri-share-forward-line"></i></Col>
              <Col><i className="ri-share-forward-2-line"></i></Col>
              <Col><i className="ri-share-forward-box-line"></i></Col>
              <Col><i className="ri-side-bar-line"></i></Col>
              <Col><i className="ri-time-line"></i></Col>
              <Col><i className="ri-timer-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-find-replace-fill"></i></Col>
              <Col><i className="ri-share-fill"></i></Col>
              <Col><i className="ri-share-box-fill"></i></Col>
              <Col><i className="ri-share-circle-fill"></i></Col>
              <Col><i className="ri-share-forward-fill"></i></Col>
              <Col><i className="ri-share-forward-2-fill"></i></Col>
              <Col><i className="ri-share-forward-box-fill"></i></Col>
              <Col><i className="ri-side-bar-fill"></i></Col>
              <Col><i className="ri-time-fill"></i></Col>
              <Col><i className="ri-timer-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-timer-2-line"></i></Col>
              <Col><i className="ri-timer-flash-line"></i></Col>
              <Col><i className="ri-alarm-line"></i></Col>
              <Col><i className="ri-history-line"></i></Col>
              <Col><i className="ri-thumb-down-line"></i></Col>
              <Col><i className="ri-thumb-up-line"></i></Col>
              <Col><i className="ri-alarm-warning-line"></i></Col>
              <Col><i className="ri-notification-badge-line"></i></Col>
              <Col><i className="ri-toggle-line"></i></Col>
              <Col><i className="ri-filter-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-timer-2-fill"></i></Col>
              <Col><i className="ri-timer-flash-fill"></i></Col>
              <Col><i className="ri-alarm-fill"></i></Col>
              <Col><i className="ri-history-fill"></i></Col>
              <Col><i className="ri-thumb-down-fill"></i></Col>
              <Col><i className="ri-thumb-up-fill"></i></Col>
              <Col><i className="ri-alarm-warning-fill"></i></Col>
              <Col><i className="ri-notification-badge-fill"></i></Col>
              <Col><i className="ri-toggle-fill"></i></Col>
              <Col><i className="ri-filter-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-filter-2-line"></i></Col>
              <Col><i className="ri-filter-3-line"></i></Col>
              <Col><i className="ri-filter-off-line"></i></Col>
              <Col><i className="ri-loader-line"></i></Col>
              <Col><i className="ri-loader-2-line"></i></Col>
              <Col><i className="ri-loader-3-line"></i></Col>
              <Col><i className="ri-loader-4-line"></i></Col>
              <Col><i className="ri-loader-5-line"></i></Col>
              <Col><i className="ri-external-link-line"></i></Col>
              <Col></Col>
              <div className="w-100"></div>
              <Col><i className="ri-filter-2-fill"></i></Col>
              <Col><i className="ri-filter-3-fill"></i></Col>
              <Col><i className="ri-filter-off-fill"></i></Col>
              <Col><i className="ri-loader-fill"></i></Col>
              <Col><i className="ri-loader-2-fill"></i></Col>
              <Col><i className="ri-loader-3-fill"></i></Col>
              <Col><i className="ri-loader-4-fill"></i></Col>
              <Col><i className="ri-loader-5-fill"></i></Col>
              <Col><i className="ri-external-link-fill"></i></Col>
              <Col></Col>
            </Row>
          </div>

          <br /><br /><br />

          <h5 id="section15" className="main-subtitle">User &amp; Faces</h5>

          <div className="icon-group">
            <Row className="gx-1 gy-2">
              <Col><i className="ri-user-line"></i></Col>
              <Col><i className="ri-user-2-line"></i></Col>
              <Col><i className="ri-user-3-line"></i></Col>
              <Col><i className="ri-user-4-line"></i></Col>
              <Col><i className="ri-user-5-line"></i></Col>
              <Col><i className="ri-user-6-line"></i></Col>
              <Col><i className="ri-user-smile-line"></i></Col>
              <Col><i className="ri-account-box-line"></i></Col>
              <Col><i className="ri-account-circle-line"></i></Col>
              <Col><i className="ri-account-pin-box-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-user-fill"></i></Col>
              <Col><i className="ri-user-2-fill"></i></Col>
              <Col><i className="ri-user-3-fill"></i></Col>
              <Col><i className="ri-user-4-fill"></i></Col>
              <Col><i className="ri-user-5-fill"></i></Col>
              <Col><i className="ri-user-6-fill"></i></Col>
              <Col><i className="ri-user-smile-fill"></i></Col>
              <Col><i className="ri-account-box-fill"></i></Col>
              <Col><i className="ri-account-circle-fill"></i></Col>
              <Col><i className="ri-account-pin-box-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-account-pin-circle-line"></i></Col>
              <Col><i className="ri-user-add-line"></i></Col>
              <Col><i className="ri-user-follow-line"></i></Col>
              <Col><i className="ri-user-unfollow-line"></i></Col>
              <Col><i className="ri-user-shared-line"></i></Col>
              <Col><i className="ri-user-shared-2-line"></i></Col>
              <Col><i className="ri-user-received-line"></i></Col>
              <Col><i className="ri-user-received-2-line"></i></Col>
              <Col><i className="ri-user-location-line"></i></Col>
              <Col><i className="ri-user-search-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-account-pin-circle-fill"></i></Col>
              <Col><i className="ri-user-add-fill"></i></Col>
              <Col><i className="ri-user-follow-fill"></i></Col>
              <Col><i className="ri-user-unfollow-fill"></i></Col>
              <Col><i className="ri-user-shared-fill"></i></Col>
              <Col><i className="ri-user-shared-2-fill"></i></Col>
              <Col><i className="ri-user-received-fill"></i></Col>
              <Col><i className="ri-user-received-2-fill"></i></Col>
              <Col><i className="ri-user-location-fill"></i></Col>
              <Col><i className="ri-user-search-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-user-settings-line"></i></Col>
              <Col><i className="ri-user-star-line"></i></Col>
              <Col><i className="ri-user-heart-line"></i></Col>
              <Col><i className="ri-admin-line"></i></Col>
              <Col><i className="ri-contacts-line"></i></Col>
              <Col><i className="ri-group-line"></i></Col>
              <Col><i className="ri-group-2-line"></i></Col>
              <Col><i className="ri-team-line"></i></Col>
              <Col><i className="ri-user-voice-line"></i></Col>
              <Col><i className="ri-emotion-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-user-settings-fill"></i></Col>
              <Col><i className="ri-user-star-fill"></i></Col>
              <Col><i className="ri-user-heart-fill"></i></Col>
              <Col><i className="ri-admin-fill"></i></Col>
              <Col><i className="ri-contacts-fill"></i></Col>
              <Col><i className="ri-group-fill"></i></Col>
              <Col><i className="ri-group-2-fill"></i></Col>
              <Col><i className="ri-team-fill"></i></Col>
              <Col><i className="ri-user-voice-fill"></i></Col>
              <Col><i className="ri-emotion-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-emotion-2-line"></i></Col>
              <Col><i className="ri-emotion-happy-line"></i></Col>
              <Col><i className="ri-emotion-normal-line"></i></Col>
              <Col><i className="ri-emotion-unhappy-line"></i></Col>
              <Col><i className="ri-emotion-laugh-line"></i></Col>
              <Col><i className="ri-emotion-sad-line"></i></Col>
              <Col><i className="ri-skull-line"></i></Col>
              <Col><i className="ri-skull-2-line"></i></Col>
              <Col><i className="ri-men-line"></i></Col>
              <Col><i className="ri-women-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-emotion-2-fill"></i></Col>
              <Col><i className="ri-emotion-happy-fill"></i></Col>
              <Col><i className="ri-emotion-normal-fill"></i></Col>
              <Col><i className="ri-emotion-unhappy-fill"></i></Col>
              <Col><i className="ri-emotion-laugh-fill"></i></Col>
              <Col><i className="ri-emotion-sad-fill"></i></Col>
              <Col><i className="ri-skull-fill"></i></Col>
              <Col><i className="ri-skull-2-fill"></i></Col>
              <Col><i className="ri-men-fill"></i></Col>
              <Col><i className="ri-women-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-travesti-line"></i></Col>
              <Col><i className="ri-genderless-line"></i></Col>
              <Col><i className="ri-open-arm-line"></i></Col>
              <Col><i className="ri-body-scan-line"></i></Col>
              <Col><i className="ri-parent-line"></i></Col>
              <Col><i className="ri-robot-line"></i></Col>
              <Col><i className="ri-aliens-line"></i></Col>
              <Col><i className="ri-bear-smile-line"></i></Col>
              <Col><i className="ri-mickey-line"></i></Col>
              <Col><i className="ri-criminal-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-travesti-fill"></i></Col>
              <Col><i className="ri-genderless-fill"></i></Col>
              <Col><i className="ri-open-arm-fill"></i></Col>
              <Col><i className="ri-body-scan-fill"></i></Col>
              <Col><i className="ri-parent-fill"></i></Col>
              <Col><i className="ri-robot-fill"></i></Col>
              <Col><i className="ri-aliens-fill"></i></Col>
              <Col><i className="ri-bear-smile-fill"></i></Col>
              <Col><i className="ri-mickey-fill"></i></Col>
              <Col><i className="ri-criminal-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-ghost-line"></i></Col>
              <Col><i className="ri-ghost-2-line"></i></Col>
              <Col><i className="ri-ghost-smile-line"></i></Col>
              <Col><i className="ri-star-smile-line"></i></Col>
              <Col><i className="ri-spy-line"></i></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <div className="w-100"></div>
              <Col><i className="ri-ghost-fill"></i></Col>
              <Col><i className="ri-ghost-2-fill"></i></Col>
              <Col><i className="ri-ghost-smile-fill"></i></Col>
              <Col><i className="ri-star-smile-fill"></i></Col>
              <Col><i className="ri-spy-fill"></i></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
            </Row>
          </div>

          <br /><br /><br />

          <h5 id="section16" className="main-subtitle">Weather</h5>

          <div className="icon-group">
            <Row className="gx-1 gy-2">
              <Col><i className="ri-sun-line"></i></Col>
              <Col><i className="ri-moon-line"></i></Col>
              <Col><i className="ri-flashlight-line"></i></Col>
              <Col><i className="ri-cloudy-line"></i></Col>
              <Col><i className="ri-cloudy-2-line"></i></Col>
              <Col><i className="ri-mist-line"></i></Col>
              <Col><i className="ri-foggy-line"></i></Col>
              <Col><i className="ri-cloud-windy-line"></i></Col>
              <Col><i className="ri-windy-line"></i></Col>
              <Col><i className="ri-rainy-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-sun-fill"></i></Col>
              <Col><i className="ri-moon-fill"></i></Col>
              <Col><i className="ri-flashlight-fill"></i></Col>
              <Col><i className="ri-cloudy-fill"></i></Col>
              <Col><i className="ri-cloudy-2-fill"></i></Col>
              <Col><i className="ri-mist-fill"></i></Col>
              <Col><i className="ri-foggy-fill"></i></Col>
              <Col><i className="ri-cloud-windy-fill"></i></Col>
              <Col><i className="ri-windy-fill"></i></Col>
              <Col><i className="ri-rainy-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-drizzle-line"></i></Col>
              <Col><i className="ri-showers-line"></i></Col>
              <Col><i className="ri-heavy-showers-line"></i></Col>
              <Col><i className="ri-thunderstorms-line"></i></Col>
              <Col><i className="ri-hail-line"></i></Col>
              <Col><i className="ri-snowy-line"></i></Col>
              <Col><i className="ri-sun-cloudy-line"></i></Col>
              <Col><i className="ri-moon-cloudy-line"></i></Col>
              <Col><i className="ri-tornado-line"></i></Col>
              <Col><i className="ri-typhoon-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-drizzle-fill"></i></Col>
              <Col><i className="ri-showers-fill"></i></Col>
              <Col><i className="ri-heavy-showers-fill"></i></Col>
              <Col><i className="ri-thunderstorms-fill"></i></Col>
              <Col><i className="ri-hail-fill"></i></Col>
              <Col><i className="ri-snowy-fill"></i></Col>
              <Col><i className="ri-sun-cloudy-fill"></i></Col>
              <Col><i className="ri-moon-cloudy-fill"></i></Col>
              <Col><i className="ri-tornado-fill"></i></Col>
              <Col><i className="ri-typhoon-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-haze-line"></i></Col>
              <Col><i className="ri-haze-2-line"></i></Col>
              <Col><i className="ri-sun-foggy-line"></i></Col>
              <Col><i className="ri-moon-foggy-line"></i></Col>
              <Col><i className="ri-moon-clear-line"></i></Col>
              <Col><i className="ri-temp-hot-line"></i></Col>
              <Col><i className="ri-temp-cold-line"></i></Col>
              <Col><i className="ri-celsius-line"></i></Col>
              <Col><i className="ri-fahrenheit-line"></i></Col>
              <Col><i className="ri-fire-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-haze-fill"></i></Col>
              <Col><i className="ri-haze-2-fill"></i></Col>
              <Col><i className="ri-sun-foggy-fill"></i></Col>
              <Col><i className="ri-moon-foggy-fill"></i></Col>
              <Col><i className="ri-moon-clear-fill"></i></Col>
              <Col><i className="ri-temp-hot-fill"></i></Col>
              <Col><i className="ri-temp-cold-fill"></i></Col>
              <Col><i className="ri-celsius-fill"></i></Col>
              <Col><i className="ri-fahrenheit-fill"></i></Col>
              <Col><i className="ri-fire-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-blaze-line"></i></Col>
              <Col><i className="ri-earthquake-line"></i></Col>
              <Col><i className="ri-flood-line"></i></Col>
              <Col><i className="ri-meteor-line"></i></Col>
              <Col><i className="ri-rainbox-line"></i></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <div className="w-100"></div>
              <Col><i className="ri-blaze-fill"></i></Col>
              <Col><i className="ri-earthquake-fill"></i></Col>
              <Col><i className="ri-flood-fill"></i></Col>
              <Col><i className="ri-meteor-fill"></i></Col>
              <Col><i className="ri-rainbox-fill"></i></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
            </Row>
          </div>

          <br /><br /><br />

          <h5 id="section17" className="main-subtitle">Others</h5>

          <div className="icon-group">
            <Row className="gx-1 gy-2">
              <Col><i className="ri-basketball-line"></i></Col>
              <Col><i className="ri-bell-line"></i></Col>
              <Col><i className="ri-billiards-line"></i></Col>
              <Col><i className="ri-boxing-line"></i></Col>
              <Col><i className="ri-cake-line"></i></Col>
              <Col><i className="ri-cake-2-line"></i></Col>
              <Col><i className="ri-cake-3-line"></i></Col>
              <Col><i className="ri-door-lock-line"></i></Col>
              <Col><i className="ri-door-lock-box-line"></i></Col>
              <Col><i className="ri-football-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-basketball-fill"></i></Col>
              <Col><i className="ri-bell-fill"></i></Col>
              <Col><i className="ri-billiards-fill"></i></Col>
              <Col><i className="ri-boxing-fill"></i></Col>
              <Col><i className="ri-cake-fill"></i></Col>
              <Col><i className="ri-cake-2-fill"></i></Col>
              <Col><i className="ri-cake-3-fill"></i></Col>
              <Col><i className="ri-door-lock-fill"></i></Col>
              <Col><i className="ri-door-lock-box-fill"></i></Col>
              <Col><i className="ri-football-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-game-line"></i></Col>
              <Col><i className="ri-handbag-line"></i></Col>
              <Col><i className="ri-key-line"></i></Col>
              <Col><i className="ri-key-2-line"></i></Col>
              <Col><i className="ri-knife-line"></i></Col>
              <Col><i className="ri-knife-blood-line"></i></Col>
              <Col><i className="ri-lightbulb-line"></i></Col>
              <Col><i className="ri-lightbulb-flash-line"></i></Col>
              <Col><i className="ri-outlet-line"></i></Col>
              <Col><i className="ri-outlet-2-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-game-fill"></i></Col>
              <Col><i className="ri-handbag-fill"></i></Col>
              <Col><i className="ri-key-fill"></i></Col>
              <Col><i className="ri-key-2-fill"></i></Col>
              <Col><i className="ri-knife-fill"></i></Col>
              <Col><i className="ri-knife-blood-fill"></i></Col>
              <Col><i className="ri-lightbulb-fill"></i></Col>
              <Col><i className="ri-lightbulb-flash-fill"></i></Col>
              <Col><i className="ri-outlet-fill"></i></Col>
              <Col><i className="ri-outlet-2-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-ping-pong-line"></i></Col>
              <Col><i className="ri-plug-line"></i></Col>
              <Col><i className="ri-plug-2-line"></i></Col>
              <Col><i className="ri-reserved-line"></i></Col>
              <Col><i className="ri-shirt-line"></i></Col>
              <Col><i className="ri-sword-line"></i></Col>
              <Col><i className="ri-t-shirt-line"></i></Col>
              <Col><i className="ri-t-shirt-2-line"></i></Col>
              <Col><i className="ri-t-shirt-air-line"></i></Col>
              <Col><i className="ri-umbrella-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-ping-pong-fill"></i></Col>
              <Col><i className="ri-plug-fill"></i></Col>
              <Col><i className="ri-plug-2-fill"></i></Col>
              <Col><i className="ri-reserved-fill"></i></Col>
              <Col><i className="ri-shirt-fill"></i></Col>
              <Col><i className="ri-sword-fill"></i></Col>
              <Col><i className="ri-t-shirt-fill"></i></Col>
              <Col><i className="ri-t-shirt-2-fill"></i></Col>
              <Col><i className="ri-t-shirt-air-fill"></i></Col>
              <Col><i className="ri-umbrella-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-character-recognition-line"></i></Col>
              <Col><i className="ri-voice-recognition-line"></i></Col>
              <Col><i className="ri-leaf-line"></i></Col>
              <Col><i className="ri-plant-line"></i></Col>
              <Col><i className="ri-seedling-line"></i></Col>
              <Col><i className="ri-recycle-line"></i></Col>
              <Col><i className="ri-scales-line"></i></Col>
              <Col><i className="ri-scales-2-line"></i></Col>
              <Col><i className="ri-scales-3-line"></i></Col>
              <Col><i className="ri-fridge-line"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-character-recognition-fill"></i></Col>
              <Col><i className="ri-voice-recognition-fill"></i></Col>
              <Col><i className="ri-leaf-fill"></i></Col>
              <Col><i className="ri-plant-fill"></i></Col>
              <Col><i className="ri-seedling-fill"></i></Col>
              <Col><i className="ri-recycle-fill"></i></Col>
              <Col><i className="ri-scales-fill"></i></Col>
              <Col><i className="ri-scales-2-fill"></i></Col>
              <Col><i className="ri-scales-3-fill"></i></Col>
              <Col><i className="ri-fridge-fill"></i></Col>
              <div className="w-100"></div>
              <Col><i className="ri-wheelchair-line"></i></Col>
              <Col><i className="ri-cactus-line"></i></Col>
              <Col><i className="ri-door-line"></i></Col>
              <Col><i className="ri-door-open-line"></i></Col>
              <Col><i className="ri-door-closed-line"></i></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <div className="w-100"></div>
              <Col><i className="ri-wheelchair-fill"></i></Col>
              <Col><i className="ri-cactus-fill"></i></Col>
              <Col><i className="ri-door-fill"></i></Col>
              <Col><i className="ri-door-open-fill"></i></Col>
              <Col><i className="ri-door-closed-fill"></i></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
            </Row>
          </div>

          <br /><br /><br />


        </Container>

        <Nav id="navDocs" className="nav-docs">
          <label>On This Page</label>
          <Nav.Link href="#section1">Buildings</Nav.Link>
          <Nav.Link href="#section2">Business</Nav.Link>
          <Nav.Link href="#section3">Communication</Nav.Link>
          <Nav.Link href="#section4">Design</Nav.Link>
          <Nav.Link href="#section5">Development</Nav.Link>
          <Nav.Link href="#section6">Device</Nav.Link>
          <Nav.Link href="#section7">Document</Nav.Link>
          <Nav.Link href="#section8">Editor</Nav.Link>
          <Nav.Link href="#section9">Finance</Nav.Link>
          <Nav.Link href="#section10">Health &amp; Medical</Nav.Link>
          <Nav.Link href="#section11">Logos</Nav.Link>
          <Nav.Link href="#section12">Map</Nav.Link>
          <Nav.Link href="#section13">Media</Nav.Link>
          <Nav.Link href="#section14">System</Nav.Link>
          <Nav.Link href="#section15">User &amp; Faces</Nav.Link>
          <Nav.Link href="#section16">Weather</Nav.Link>
          <Nav.Link href="#section17">Others</Nav.Link>
        </Nav>
      </div>
      {/* <Footer /> */}
    </React.Fragment>
  );
}